const propertyProData = [
  {
    listingTitile: "Newly Renovated & Spacious 4bedoom Duplex (no Bq)..",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Adeniran Ogunsanya",
    city: "Surulere",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08167742895",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-adeniran-ogunsanya-surulere-lagos-9GXUF",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached For Rent",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-6GXUF",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07047998445",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GNBB",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ologolo-lekki-lagos-7GXSF",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Apartment",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Spar Road Just By House On The Rock And Nicon Town Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-spar-road-just-by-house-on-the-rock-and-nicon-town-ikate-lekki-lagos-1GXSF",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Mini Flat",
    price: "1500000",
    bathrooms: "2",
    beds: "1",
    toilets: "3",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-agungi-lekki-lagos-8GXSE",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-7GXSE",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2800000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09035137760",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ologolo-lekki-lagos-5GXSD",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace House",
    price: "15000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08082163583",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-ikoyi-lagos-1GXKQ",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "6 Bedroom Duplex",
    price: "15000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Pinnock Beach",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08060623971",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-pinnock-beach-lekki-lagos-5GXRL",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "2 Units Of 4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Atlantic Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-atlantic-ologolo-lekki-lagos-3GXFP",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Luxury 3 Bedroom Terrace House",
    price: "15000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08124269637",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-ikoyi-lagos-0GXQK",
    dateUpdated: "09 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Victoria Nest, Chevron Drive.",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-victoria-nest-chevron-drive-lekki-lagos-1GXFQ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "19 Units Of Fully Serviced 3 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agungi-lekki-lagos-9GTRS",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "16000000",
    bathrooms: "3",
    beds: "4",
    toilets: "4",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-0GNVC",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: " ",
    beds: "3",
    toilets: " ",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08036411790",
    imagesProvided: "5",
    listingURL: "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-lagos-3GUED",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Fully Detached 5 Bedroom Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Omole Phase 2",
    city: "Ojodu",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08054797512",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-omole-phase-2-ojodu-lagos-3GPTC",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "54000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "United Nations Office",
    city: "Asokoro",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08053979149",
    imagesProvided: "25",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-united-nations-office-asokoro-abuja-1GWEE",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "25000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Old Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-old-ikoyi-old-ikoyi-ikoyi-lagos-8GVZP",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Megamound Estate, Lekki County Homes, Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07057302511",
    imagesProvided: "35",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-megamound-estate-lekki-county-homes-ikota-lekki-lagos-9GPZL",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-9GWAW",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-1GWLX",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-lekki-lagos-6GWJP",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-agungi-lekki-lagos-7GWKC",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 3 Bedroom Semi Detached For Rent",
    price: "4500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agungi-lekki-lagos-7GUUC",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "20000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-4GQSG",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron. Gate, Orchid Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-gate-orchid-chevron-lekki-lagos-5GSPP",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "10000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Banana Islnd Road",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-islnd-road-ikoyi-lagos-1GPQF",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "Spacious 5 Bedroom Fully Detached Duplex",
    price: "7500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ogudu Gra",
    city: "Ogudu",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08167742895",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ogudu-gra-ogudu-lagos-1GXDY",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-0GWLU",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "10000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-island-lagos-6GXEL",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-1GMXX",
    dateUpdated: "04 May 2022",
  },
  {
    listingTitile: "Brand New 2 Bedroom Apartment",
    price: "3000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "By Conservation Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-by-conservation-road-chevron-lekki-lagos-5GNXT",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Katampe Extention Katampe",
    city: "Ext",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08036492297",
    imagesProvided: "31",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-katampe-extention-katampe-ext-abuja-2GUVR",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GSMH",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-0GWNC",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 2 Bedroom Flat",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agungi-lekki-lagos-2GVWQ",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Fully Furnished Apartment",
    price: "3500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Along World Oil Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-along-world-oil-ikate-lekki-lagos-0GVXU",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-1GTJA",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "13000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-1GSSP",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lekki Conservation Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-conservation-road-chevron-lekki-lagos-2GVCZ",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Tetrace Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-1GKYR",
    dateUpdated: "19 Apr 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "5000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikate-lekki-lagos-1GUDH",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Newly Built & Tastefully Finished 3bedroom Terrace Duplex + A Room Bq......",
    price: "7000000",
    bathrooms: "4",
    beds: "3",
    toilets: "5",
    street: "Ikeja Gra",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08167742895",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikeja-gra-ikeja-lagos-2GNMH",
    dateUpdated: "09 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09121180993",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agungi-lekki-lagos-2GUDN",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-chevron-lekki-lagos-7GVXU",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 3 Bedroom Apartment",
    price: "11000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-ikoyi-lagos-9GVXC",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-0GVBH",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "6",
    beds: "4",
    toilets: "6",
    street: "unstated",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ajah-lagos-8GWTP",
    dateUpdated: "02 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-7GXGK",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2200000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "4avenue Gwarimpa",
    city: "Gwarinpa",
    state: "Abuja",
    status: "old",
    agentContact: "08036492297",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-4avenue-gwarimpa-gwarinpa-abuja-8GULL",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GVXD",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ologolo-lekki-lagos-5GNAS",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-6GNAT",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08139265236",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-7GTRE",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-2GVBH",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "5500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-1GQRQ",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-3GNAT",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-2GSSH",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "Well Furnished 4 Bedroom Semi Detached Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08033354125",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-1GNPL",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "1 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "1",
    toilets: "2",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-chevron-lekki-lagos-9GWNV",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-0GMTA",
    dateUpdated: "03 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Diamond Estate Monastery Road",
    city: "Sangotedo",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08060623971",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-diamond-estate-monastery-road-sangotedo-lagos-1GUPS",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "3500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street:
      "Cromwell Estate,milverton Estate,friends Colony ,bourdillon Court ,cardogan Chevron Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08168064058",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-cromwell-estatemilverton-estatefriends-colony-bourdillon-court-cardogan-chevron-chevron-lekki-lagos-0GTJQ",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "8000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-victoria-island-lagos-8GPKZ",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Mabushi",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08036492297",
    imagesProvided: "24",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-mabushi-abuja-4GVCZ",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "3500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ologolo-lekki-lagos-7GWNE",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GNXH",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Victoria Bay Estate, Off Orchid Road, Lekki, Lagos Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08183000015",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-victoria-bay-estate-off-orchid-road-lekki-lagos-chevron-lekki-lagos-6GVXM",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-chevron-lekki-lagos-1GUKR",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached House",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Admiralty Way Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08059149400",
    imagesProvided: "30",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-admiralty-way-lekki-phase-1-lekki-lagos-9GWNL",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Conservation Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-conservation-road-chevron-lekki-lagos-2GPAH",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "12000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Juat By Nicon Town Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-juat-by-nicon-town-ikate-lekki-lagos-4GUGG",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-9GUKN",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-4GSTY",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "16500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Mojisola Onikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-mojisola-onikoyi-ikoyi-lagos-6GTBL",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "25000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-2GQSG",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-7GVXC",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Semi Detached",
    price: "9000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09041150803",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-0GTEK",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "Serviced 2 Bedroom Flat",
    price: "5000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-agungi-lekki-lagos-3GVWQ",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "10000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-island-lagos-5GVWP",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "7000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-2GSMD",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Duplex",
    price: "3000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Badore",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-badore-ajah-lagos-4GVBA",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "6500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08139265236",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GTYN",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "3200000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-osapa-london-lekki-lagos-5GSSF",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Maisonette",
    price: "7500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-lagos-9GWYT",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Serviced 3 Bedroom Apartment",
    price: "6500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oniru-victoria-island-lagos-3GWND",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-7GXEF",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Fully Serviced 3 Bedroom Bungalow",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "South Pointe Estate,orchid Road",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08168064058",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-south-pointe-estateorchid-road-lekki-lagos-1GUGT",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "12000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oniru-victoria-island-lagos-8GUKU",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "3bedroom Semi Detached Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-sangotedo-ajah-lagos-6GPKJ",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "7000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-9GSNG",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "7000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-7GSMC",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-9GQKE",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "3000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ajah-lagos-8GXGJ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GVTA",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Apartment",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Unilag Estate, Isheri, Magodo Phase 1 Gra Magodo Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09068786533",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-unilag-estate-isheri-magodo-phase-1-gra-magodo-kosofe-ikosi-lagos-3GWLJ",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "9000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GUKR",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "1 Bedroom Mini Flat",
    price: "1500000",
    bathrooms: "2",
    beds: "1",
    toilets: "2",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-agungi-lekki-lagos-1GWNW",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street:
      "Chevron Drive, Few Minutes Drive From Atlantic Mall Opposite Uba And Bera Estate Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-drive-few-minutes-drive-from-atlantic-mall-opposite-uba-and-bera-estate-gate-chevron-lekki-lagos-9GSPM",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-1GUKQ",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Bera Estate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-bera-estate-chevron-lekki-lagos-8GSVS",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-chevron-lekki-lagos-9GWTQ",
    dateUpdated: "02 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-7GSTX",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "15000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-0GWYR",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Flat",
    price: "10000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Banana Island Road",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-road-ikoyi-lagos-9GUKV",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Standard 6 Bedroom Duplex",
    price: "5500000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Brains And Hammers Estate",
    city: "Apo",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08160442385",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-brains-and-hammers-estate-apo-abuja-8GNRN",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Luxurious 4 Bedroom Terrace Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Katampe",
    city: "Ext",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08036492297",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-katampe-ext-abuja-6GNXX",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lekki Conservation Center Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-conservation-center-chevron-lekki-lagos-4GXBU",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-8GSPM",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "300000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-3GULY",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached House",
    price: "7000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-1GUUE",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-toll-gate-chevron-lekki-lagos-0GNHQ",
    dateUpdated: "07 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "13500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-8GUXY",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Fully Furnished 4 Bedroom Semi Detached Duplex",
    price: "9000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-9GPKZ",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-8GWND",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Serviced 3 Bedroom Apartment",
    price: "7500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oniru-victoria-island-lagos-2GXEJ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Furnished 4 Bedroom Terrace Duplex",
    price: "10000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-victoria-island-lagos-3GTUR",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "9000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09035137760",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-4GVBH",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Palm City Estate",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09034504273",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-palm-city-estate-ajah-lagos-5GWEC",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08067329172",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-agungi-lekki-lagos-9GWYM",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09034504273",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-6GXEJ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lbs Ajah",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09034504273",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lbs-ajah-ajah-lagos-1GWZS",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Terraced Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09062511340",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-victoria-island-lagos-7GEAH",
    dateUpdated: "07 Mar 2022",
  },
  {
    listingTitile: "Tastefully Finished 3bedroom Detached Duplex In Majek, Sangotedo For Rent",
    price: "2000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Majek",
    city: "Sangotedo",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08060255244",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-majek-sangotedo-lagos-7GXVY",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedrooms Flat With Wardrobe All Ensuit",
    price: "2500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "By Ics Dakibiyu",
    city: "Dakibiyu",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08067992859",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-by-ics-dakibiyu-dakibiyu-abuja-8GXVW",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile:
      "Property For Rent 4bedroom Terrace Duplex But No Bq Inside An Estate In Off Adeniyi Jones. This Is 4bedroom Terrace Duplex But No Bq Inside An Estate In Off Adeniyi Jones Avenue Ikeja Lagos. All The Rooms Are En Suite With Guest Toilets ?? Rent 5m/ Legal",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Adeniyi Jones",
    city: "Ikeja",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07036613677",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-adeniyi-jones-ikeja-lagos-7GXVW",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "54000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Asokoro",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "07033122411",
    imagesProvided: "22",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-asokoro-abuja-7GWNQ",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Newly Built Room Self Contain",
    price: "250000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Orogun/ui",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "07065057152",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-orogun-ui-ibadan-oyo-2GXBW",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile:
      "Brand New Self Serviced 5 Bedroom Detached House And A Bq For Rent In Ikate, Lekki.",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09071394259",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-4GXVS",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "4bed Duplex Magodo Gra Phase 2 Estate 24hours Light",
    price: "3800000",
    bathrooms: " ",
    beds: "4",
    toilets: " ",
    street: "Magodo Gra Phase 2 Estate Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09023459596",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-magodo-gra-phase-2-estate-magodo-gra-phase-2-kosofe-ikosi-lagos-1GXVR",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "New House",
    price: "8000000",
    bathrooms: " ",
    beds: "4",
    toilets: " ",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08126572402",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-0GXVM",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Serviced & Spacious 4 Bedroom Maisonnette Plus A Bq,",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-4GXVL",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Fully Serviced Three (3) Bedroom Semi Detached Duplex;",
    price: "4500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Bakare Estate Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-bakare-estate-agungi-lekki-lagos-8GXVK",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Luxury 3 Bedroom All Rooms En Suite Semi Detached Duplex Plus A Room Bq",
    price: "5500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08164687732",
    imagesProvided: "25",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GXVF",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Split Level House With Boys Quarters.",
    price: "11000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Off Admiralty Way Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08033090955",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-off-admiralty-way-lekki-phase-1-lekki-lagos-3GWBT",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "4bedroom Plus Bq",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Orchid Road. Not Fa R Inside",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09064090448",
    imagesProvided: "23",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-orchid-road-not-fa-r-inside-lekki-lagos-4GXVF",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Fully Detached With Bq",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08142223792",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-lekki-lagos-0GXVC",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 2",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08135540360",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-2-lekki-lagos-5GKXV",
    dateUpdated: "19 Apr 2022",
  },
  {
    listingTitile: "24hours Serviced 4bedroom",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Van Daniel Court,orchid Road, Chevron Tollgate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08089633335",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-van-daniel-courtorchid-road-chevron-tollgate-chevron-lekki-lagos-7GXUU",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Semi Detached Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09071394259",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-2GXSC",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Fully Furnished 5 Bedroom Detached Duplex",
    price: "25000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08135540360",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GSQY",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex House",
    price: "3500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08135540360",
    imagesProvided: "11",
    listingURL: "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-lagos-0GWQS",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "A Standard Three Bedroom Terrace Duplex",
    price: "1500000",
    bathrooms: " ",
    beds: "3",
    toilets: " ",
    street: "Badore Road Badore",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "07031120682",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-badore-road-badore-ajah-lagos-0GPAM",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious Brand New 4bedroom Terrace Duplex With 1room Bq",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Jahi District",
    city: "Jahi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "27",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jahi-district-jahi-abuja-6GXUB",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious 5bedroom Twin Duplex With 1room Bq",
    price: "20000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Asokoro District",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-asokoro-district-asokoro-abuja-2GXUB",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "A Very Spacious Fully Detached 5bedroom Duplex",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Maitama District(aso Drive)",
    city: "Maitama",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-maitama-districtaso-drive-maitama-abuja-9GXTY",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "Tastefully Finished And Newly Built Fully Detached 3 Bedroom Bungalow With Bq",
    price: "2000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Lugbe Axis Abuja",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lugbe-axis-abuja-lugbe-abuja-6GXTY",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious Serviced 4bedroom Terrace Duplex With 1room Bq",
    price: "12500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Wuse2 District Wuse",
    city: "2",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuse2-district-wuse-2-abuja-0GXTY",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious 4bedroom Terrace Duplex With 1room Bq",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Jahi District",
    city: "Jahi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jahi-district-jahi-abuja-1GXTX",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "1500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Phase 2 Lekki Gardens Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08121377323",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-phase-2-lekki-gardens-estate-ajah-lagos-6GTVC",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious 6bedroom Fully Detached Duplex With 4room Bq",
    price: "20000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Maitama District(aso Drive)",
    city: "Maitama",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-maitama-districtaso-drive-maitama-abuja-6GXTW",
    dateUpdated: "12 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Main Gwarinpa",
    city: "Gwarinpa",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08137377290",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-main-gwarinpa-gwarinpa-abuja-2GXSW",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Bungalow",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ada George Port",
    city: "Harcourt",
    state: "Rivers",
    status: "Newly Built",
    agentContact: "08063105936",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ada-george-port-harcourt-rivers-5GXST",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Fully Furnished 3 Bedroom Terrace Duplex",
    price: "8000000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Chevron Alternative Drive Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09027260414",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-chevron-alternative-drive-chevron-lekki-lagos-4GPKG",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "700000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Airforce Area, Abake Estate Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08187281313",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-airforce-area-abake-estate-akobo-ibadan-oyo-5GWWK",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Flat",
    price: "600000",
    bathrooms: "2",
    beds: "4",
    toilets: "3",
    street: "Bolumole Street Ring Rd",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08187281313",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-bolumole-street-ring-rd-ibadan-oyo-1GWYX",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "600000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Adeoje Estate Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08187281313",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-adeoje-estate-akala-express-ibadan-oyo-2GWZR",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-lekki-lagos-8GXRD",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-5GXRD",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Terrace Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "13",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ajah-lagos-4GXRD",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09034420031",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ologolo-lekki-lagos-2GXRD",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terraced Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08037836842",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GUDA",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "5 Units Of 5 Bedroom Fully Detached Duplex",
    price: "18000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Phase 2 Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08024025048",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-phase-2-osborne-foreshore-estate-ikoyi-lagos-0GXQY",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "10000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08024025048",
    imagesProvided: "18",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-lagos-8GXQX",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached House",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Right.",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-right-lekki-lagos-7GSJL",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Terrace House",
    price: "16000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-9FEMW",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-2GCJX",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "23000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07025007793",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-4GWZF",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Well Built 5 Bedroom Fully Detached Duplex",
    price: "130000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08082163583",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-4GVFD",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Terrace Duplex",
    price: "20000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikoyi-lagos-3GUCF",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08082163583",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-0GUPU",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Numbers Of 4 Bedroom Terrace Duplex",
    price: "100000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "6",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikoyi-lagos-9EMXC",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-6GTBZ",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07025007793",
    imagesProvided: "5",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-lagos-5GWYM",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Terrace House",
    price: "14000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "22",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-4FEQN",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex With A Bq",
    price: "17000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-banana-island-ikoyi-lagos-0GNEL",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached House",
    price: "14500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Off Onikoyi Road Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-off-onikoyi-road-ikoyi-old-ikoyi-ikoyi-lagos-4EEKN",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-lekki-lagos-0GRZU",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace",
    price: "13000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-1GSDS",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-lekki-lagos-7GTCC",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Terrace Duplex",
    price: "25000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-9GUCL",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-7GUGN",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-6GQEZ",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "18",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ajah-lagos-6GQFE",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-6GPSF",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Units Of 4 Bedroom Terrace House",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-parkview-estate-ikoyi-lagos-9GAPG",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "25000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-8EYAB",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached House",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07025007793",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-phase-1-lekki-lagos-7GWNU",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07025007793",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-1GWZF",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-4GRGL",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached House",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-0FHAN",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Gerald Court Rasheed Alaba Williams Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-gerald-court-rasheed-alaba-williams-lekki-phase-1-lekki-lagos-4GVAW",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Idado",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-idado-lekki-lagos-2GVUW",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "14000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-2FGRQ",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached House + Bq+ Gym + Pool",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-7FYKJ",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-8FSJB",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "1800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Opic Estate Isheri North",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "08177766115",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-opic-estate-isheri-north-ojodu-lagos-7GVWP",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-2GQRJ",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached House",
    price: "12500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osborne 1 Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osborne-1-osborne-foreshore-estate-ikoyi-lagos-5FYCE",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Spacious 5 Bedroom Fully Detached Duplex",
    price: "35000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikoyi-lagos-9GNSE",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Tastefully Built 5 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-6GNSH",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-4GPSD",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-4GPSP",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4200000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid Road",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-road-lekki-lagos-5GTBW",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "New Road",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-new-road-lekki-lagos-0GTJC",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "Nicely Built 5 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-lekki-lagos-2GUGQ",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-9GSXC",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki County Homes Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-county-homes-ikota-lekki-lagos-2GVXX",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "6 Bedroom Fully Detached Duplex",
    price: "30000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Close To Ecowas",
    city: "Asokoro",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08053979149",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-close-to-ecowas-asokoro-abuja-9GPCY",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "18000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-8GJVV",
    dateUpdated: "09 Apr 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-0GPGA",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08082163583",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-9GVLG",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Second Tollgate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-second-tollgate-lekki-lagos-2GWBG",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Brand New 5 Bedroom Detached House",
    price: "6500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-3GRTD",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "Self Serviced 4 Bedroom Massionette",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Parkview Estate Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-parkview-estate-parkview-estate-ikoyi-lagos-9GNWL",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-lekki-lagos-9GTBV",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Terrace House",
    price: "18000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-2EVNX",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House + Bq",
    price: "19000000",
    bathrooms: "4",
    beds: "5",
    toilets: "5",
    street: "Old Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-old-ikoyi-old-ikoyi-ikoyi-lagos-2GDMG",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Maisonette",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-7FXLR",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Maisonette",
    price: "13500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-9FUVW",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-5GXFN",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Nicely Built 4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GSJQ",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Maisonette + Bq+ Pool Gym Etc In Central Ikoyi @n15m",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-old-ikoyi-ikoyi-lagos-7FYBK",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "7500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Close To Old Cbn Garki",
    city: "2",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08053979149",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-close-to-old-cbn-garki-2-abuja-2GWFC",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "70000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron Drive",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-drive-lekki-lagos-5GVBC",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Semi Detached House",
    price: "20000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-4FYCH",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "12000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-0ERDX",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "4500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Close To Nnpc Fuel Station",
    city: "Guzape",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08053979149",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-close-to-nnpc-fuel-station-guzape-abuja-7GWFC",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "6 Bedrooms Detached House",
    price: "35000000",
    bathrooms: "5",
    beds: "6",
    toilets: "5",
    street: "Off Kindsway Road Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "090902999998",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-off-kindsway-road-old-ikoyi-ikoyi-lagos-9GVEX",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08082163583",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-9GXBP",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Terrace House",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osborne 2 Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08124269637",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osborne-2-osborne-foreshore-estate-ikoyi-lagos-3GDKN",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Semi Detached Terrace House",
    price: "20000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-3GCZG",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace House",
    price: "13000000",
    bathrooms: "2",
    beds: "3",
    toilets: "3",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-9GKDY",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached House + Bq",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08124269637",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-8ELXQ",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Tastefully Built 2 Bedroom Apartment",
    price: "450000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Dove Estate Ajila Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08148211572",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-dove-estate-ajila-akala-express-ibadan-oyo-3GSYV",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4bedroom Semi Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09058185397",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-7GRNC",
    dateUpdated: "28 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "5000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Fola Osibo Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-fola-osibo-lekki-phase-1-lekki-lagos-2GVRH",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Oral Estate 2nd Toll Gate Lekki Lagos State Lekki Phase 2",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07088623980",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-oral-estate-2nd-toll-gate-lekki-lagos-state-lekki-phase-2-lekki-lagos-7GNEN",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached House",
    price: "3000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Abraham Adesanya Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08027725974",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-abraham-adesanya-estate-ajah-lagos-7GWPN",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Fully Serviced 3 Bedroom Apartment",
    price: "7000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Adeola Odeku Adeola Odeku Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-adeola-odeku-adeola-odeku-victoria-island-lagos-8GVRK",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "Nice 3 Bedroom Flat",
    price: "5000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GTHT",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Off Omorire Johnson Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-off-omorire-johnson-lekki-phase-1-lekki-lagos-4GUAM",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09058185397",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-1GQRB",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "10000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Adeola Odeku Adeola Odeku Victoria",
    city: "Island",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08143129775",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-adeola-odeku-adeola-odeku-victoria-island-lagos-9GVRF",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "3 Unit Of 4 Bedroom Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Sharp Corner Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "09023730900",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-sharp-corner-oluyole-estate-ibadan-oyo-8GPSE",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedroom Apartment",
    price: "900000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Bovas Oluyole Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "08148211572",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-bovas-oluyole-oluyole-estate-ibadan-oyo-0GUQN",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "400000",
    bathrooms: " ",
    beds: "2",
    toilets: " ",
    street: "Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "08148211572",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-akala-express-ibadan-oyo-8GSZB",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Well Furnished 4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-1GQKL",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex",
    price: "16000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Maitama",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08095437078",
    imagesProvided: "22",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-maitama-abuja-0GRAT",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "2500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Near Foodco Jericho",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "09023730900",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-near-foodco-jericho-ibadan-oyo-8GVXW",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Corner Piece Detached House",
    price: "20000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Street Ademola Adetokunbo Victoria",
    city: "Island",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-street-ademola-adetokunbo-victoria-island-lagos-5GTVD",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "6 Bedroom Fully Detached Duplex",
    price: "7000000",
    bathrooms: "7",
    beds: "6",
    toilets: "7",
    street: "Gwarinpa",
    city: "Gwarinpa",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08033229835",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-gwarinpa-gwarinpa-abuja-1GRGS",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Fully Detached Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate Elegushi Lekki Phase 1 Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07031876847",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-elegushi-lekki-phase-1-ikate-lekki-lagos-2GVUP",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "8000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ligali Ayorinde Victoria",
    city: "Island",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08143129775",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ligali-ayorinde-victoria-island-lagos-1GVGE",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "1000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ade Oyo Ring Rd",
    city: "Ibadan",
    state: "Oyo",
    status: "Furnished",
    agentContact: "08148211572",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ade-oyo-ring-rd-ibadan-oyo-8GSQS",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "Beautiful 4 Bedroom Terrace House",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "09058185397",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-3GWVR",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "4bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "09058185397",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GRGE",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "700000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Akoto Estate Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "FurnishedServiced",
    agentContact: "08148211572",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-akoto-estate-akala-express-ibadan-oyo-8GRYH",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "New House",
    price: "600000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Life",
    city: "Camp",
    state: "Abuja",
    status: "FurnishedServiced",
    agentContact: "09039632691",
    imagesProvided: "3",
    listingURL: "https://www.propertypro.ng/property/house-for-rent-life-camp-abuja-8FSXB",
    dateUpdated: "28 Nov 2021",
  },
  {
    listingTitile: "Tastefully Built Spacious 3 Bedroom Flat",
    price: "450000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Ayilara Street Sharp Corner Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "FurnishedServiced",
    agentContact: "09023730900",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ayilara-street-sharp-corner-oluyole-estate-ibadan-oyo-6GVXK",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron Lekki Lagos State Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07088623980",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-state-chevron-lekki-lagos-8GQFG",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08027725974",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GRPT",
    dateUpdated: "29 May 2022",
  },
  {
    listingTitile: "Spacious 5 Bedroom Detached House",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Idado, Lekki Lagos Idado",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07088623980",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-idado-lekki-lagos-idado-lekki-lagos-6GPAJ",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09058185397",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GUFN",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Oral Estate 2nd Toll Gate Lekki Lagos State Lekki Phase 2",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07088623980",
    imagesProvided: "24",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oral-estate-2nd-toll-gate-lekki-lagos-state-lekki-phase-2-lekki-lagos-8GNEN",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "5 Bedroom Furnished Terrace Duplex",
    price: "6500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Adeniyi Jones",
    city: "Ikeja",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-adeniyi-jones-ikeja-lagos-0GTKH",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "25000000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Off Oron Road Uyo",
    city: "Akwa",
    state: "Ibom",
    status: "Newly Built",
    agentContact: "08034511039",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-oron-road-uyo-akwa-ibom-9GVSR",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 3 Bedroom Apartment",
    price: "6000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08143129775",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GVRJ",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Admiralty Way Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07031876847",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-admiralty-way-lekki-phase-1-lekki-lagos-7GVBQ",
    dateUpdated: "01 Mar 2022",
  },
  {
    listingTitile: "3 Bedroom Duplex",
    price: "2000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-akobo-ibadan-oyo-1GSKK",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Bungalow",
    price: "10000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Wuse",
    city: "2",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08095437078",
    imagesProvided: "4",
    listingURL: "https://www.propertypro.ng/property/3-bedroom-house-for-rent-wuse-2-abuja-8GXBZ",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Serviced 3 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GUEB",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "3000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08143129775",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GUPJ",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-8GWDR",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Fully Detached Duplex",
    price: "10000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1 Right Hand Side Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07031876847",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-right-hand-side-lekki-phase-1-lekki-lagos-2GUZV",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Brand New 3 Bedroom Terrace Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08027725974",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikota-lekki-lagos-0GWMP",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached House",
    price: "18000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08027725974",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osborne-foreshore-estate-ikoyi-lagos-2GWLU",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Magodo Phase1 Gra Magodo Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08143129775",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-magodo-phase1-gra-magodo-kosofe-ikosi-lagos-1GTTP",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "4bedroom Fully Detached Duplex",
    price: "5500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08027725974",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-1GMUF",
    dateUpdated: "04 May 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Neighborhood Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08027725974",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-neighborhood-osapa-london-lekki-lagos-7GQKK",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached House",
    price: "15000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Street Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08027725974",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-street-lekki-phase-1-lekki-lagos-4GPQM",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "800000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Bashorun Housing Estate Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09023730900",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-bashorun-housing-estate-akobo-ibadan-oyo-7GTCY",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "4bedroom Terrace Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Street Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08027725974",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-street-lekki-phase-1-lekki-lagos-7GRCV",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "Fully Serviced 5 Bedroom Semi Detached Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-lekki-lagos-2GXNU",
    dateUpdated: "08 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Hillcrest Estate Behind Roban Store",
    city: "Enugu",
    state: "Enugu",
    status: "Serviced",
    agentContact: "08060036824",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-hillcrest-estate-behind-roban-store-enugu-enugu-7GXMN",
    dateUpdated: "08 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "13000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07036613677",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osborne-foreshore-estate-ikoyi-lagos-9GXMM",
    dateUpdated: "08 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07051883525",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-9GUFE",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08035770700",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-ikota-lekki-lagos-8GJDL",
    dateUpdated: "04 Apr 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Oniru Victoria Island Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09041150803",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-victoria-island-oniru-victoria-island-lagos-3GSHA",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Cjevron Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08168064058",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-cjevron-chevron-lekki-lagos-3GPPE",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "4bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09041150803",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-parkview-estate-ikoyi-lagos-5GNHS",
    dateUpdated: "07 May 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07047998445",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-1GRHC",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "Automated 3 Bedroom Apartment",
    price: "14000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07047998445",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GSQG",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "Lovely 3 Bedroom Terraced Duplex",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Victoria Crest 2 Orchid Road",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09061623299",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-crest-2-orchid-road-lekki-lagos-7GVAT",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Decent 4 Bedroom Duplex",
    price: "2000000",
    bathrooms: "3",
    beds: "4",
    toilets: "3",
    street: "Off Oduduwa Street Kilo Marsha",
    city: "Surulere",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09061623299",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-oduduwa-street-kilo-marsha-surulere-lagos-3GWDS",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Spring Garden Estate, Orchid Road",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09061623299",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-spring-garden-estate-orchid-road-lekki-lagos-3GXFG",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Executive 5 Bedroom Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Divine Estate Puposola Oko Oba",
    city: "Agege",
    state: "Lagos",
    status: "old",
    agentContact: "09061623299",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-divine-estate-puposola-oko-oba-agege-lagos-7GSTQ",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "16000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08139265236",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-ikoyi-lagos-7GRRN",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08139265236",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-2GUUG",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "Standard 5 Bedroom",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Wuye",
    state: "Abuja",
    status: "old",
    agentContact: "08160442385",
    imagesProvided: "20",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-wuye-abuja-2GSVZ",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terraced Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Ahmadu Bello Way Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08059149400",
    imagesProvided: "30",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-ahmadu-bello-way-victoria-island-lagos-4GVCB",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07047998445",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-8GWSA",
    dateUpdated: "02 Jul 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08067329172",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-4GXCQ",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-4GMZL",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Terraced Duplex With Bq",
    price: "3300000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Abraham Adesanya",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-abraham-adesanya-ajah-lagos-4GNWM",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "Spacious 2 Bedroom Terrace Duplex",
    price: "3200000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09041150803",
    imagesProvided: "9",
    listingURL: "https://www.propertypro.ng/property/2-bedroom-house-for-rent-lekki-lagos-6GWYK",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "3300000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Chevron Tollgate Orchid Hotel Road",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-chevron-tollgate-orchid-hotel-road-lekki-lagos-1GUVS",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Fully Detached Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-6GPDY",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "Newly Built & Tastefully Finished 4bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Millenuim Ups",
    city: "Gbagada",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08167742895",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-millenuim-ups-gbagada-lagos-9GNKK",
    dateUpdated: "09 May 2022",
  },
  {
    listingTitile: "Fully Furnished 3 Bedroom Semi Detached Duplex",
    price: "3000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Palm City Estate",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-palm-city-estate-ajah-lagos-9GVAW",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08168064058",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-chevron-lekki-lagos-4GXLA",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Gwarinpa",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08036492297",
    imagesProvided: "4",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-gwarinpa-abuja-8GXHU",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex With Bq",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Thomas Estate",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09034504273",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-thomas-estate-ajah-lagos-6GNXK",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Terrace Duplex",
    price: "28000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07047998445",
    imagesProvided: "8",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikoyi-lagos-4GXCY",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "1500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Lokogoma Abuja",
    city: "Lokogoma",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-lokogoma-abuja-lokogoma-abuja-5GXKU",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Promenade Estate",
    city: "Lokogoma",
    state: "Abuja",
    status: "old",
    agentContact: "07033122411",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-promenade-estate-lokogoma-abuja-1GXKU",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Street Garki",
    city: "1",
    state: "Abuja",
    status: "old",
    agentContact: "08055070928",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-street-garki-1-abuja-9GXKS",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09067320607",
    imagesProvided: "25",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-7GPLZ",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "Self Contain",
    price: "350000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Garki",
    city: "1",
    state: "Abuja",
    status: "old",
    agentContact: "08055070928",
    imagesProvided: "8",
    listingURL: "https://www.propertypro.ng/property/1-bedroom-house-for-rent-garki-1-abuja-5GWHE",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "12 Bedroom Mansion",
    price: "40000000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Bourdillon",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "09067320607",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/10-bedroom-house-for-rent-bourdillon-ikoyi-lagos-9GJFZ",
    dateUpdated: "05 Apr 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota Gra",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-gra-lekki-lagos-2GXHK",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Executive 4 Bedroom Terrace Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08100073388",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-5GXHF",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Orchid/ 2nd Lekki Toll Gate Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08060283193",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-2nd-lekki-toll-gate-agungi-lekki-lagos-4GVAZ",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07031264489",
    imagesProvided: "22",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-8GUQA",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron Drive Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08117340933",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-drive-chevron-lekki-lagos-6GUPX",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08117340933",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-1GRJQ",
    dateUpdated: "27 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Adetola Aguda Surulere Lagos Aguda",
    city: "Surulere",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08186532571",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-adetola-aguda-surulere-lagos-aguda-surulere-lagos-9GUPR",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Cheveron Alternative Route. Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08075711336",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-cheveron-alternative-route-chevron-lekki-lagos-1GUNR",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Harris Drive Vgc",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08060283193",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-harris-drive-vgc-lekki-lagos-3GXCB",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Furnished 4 Bedroom Terrace Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08105605371",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-8GVVL",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevy View Estate, Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08141878209",
    imagesProvided: "47",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevy-view-estate-chevron-lekki-lagos-4GLHA",
    dateUpdated: "21 Apr 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid Road",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07031264489",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-road-lekki-lagos-2GPZZ",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "Spacious Block Of 2flats Of 4bedroom And 3bedroom Flats In Surulere",
    price: "4000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Off Ogunlana Drive Surulere Ogunlana",
    city: "Surulere",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08186532571",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-off-ogunlana-drive-surulere-ogunlana-surulere-lagos-9GQYH",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08117340933",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-1GPPP",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "3000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07030598736",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ikate-lekki-lagos-8GTEV",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "400000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Awobo Igbogbo",
    city: "Ikorodu",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07010568925",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-awobo-igbogbo-ikorodu-lagos-4GWTZ",
    dateUpdated: "03 Jul 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Bungalow",
    price: "2000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Ifako Gbagba By Global Impact Church, Ifako Gbagada",
    city: "Gbagada",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08133154602",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ifako-gbagba-by-global-impact-church-ifako-gbagada-gbagada-lagos-2GVGV",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "350000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Merit Estate Igbogbo",
    city: "Ikorodu",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07010568925",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-merit-estate-igbogbo-ikorodu-lagos-6GWYJ",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "600000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Oluodo Ebute",
    city: "Ikorodu",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07010568925",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oluodo-ebute-ikorodu-lagos-3GWTZ",
    dateUpdated: "03 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08135540360",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GQDS",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Duplex",
    price: "88000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08135540360",
    imagesProvided: "18",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-lagos-3GQXP",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Semi Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08135540360",
    imagesProvided: "11",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikoyi-lagos-7GTEQ",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08160772746",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-5GUWW",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07086048604",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-1GRJB",
    dateUpdated: "27 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08117340933",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GRUN",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "350000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Banjoko Igbogbo",
    city: "Ikorodu",
    state: "Lagos",
    status: "old",
    agentContact: "07010568925",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banjoko-igbogbo-ikorodu-lagos-1GXBH",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07086048604",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-2GWND",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Semi Detached 4 Bedroom Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09067320607",
    imagesProvided: "25",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GWTV",
    dateUpdated: "03 Jul 2022",
  },
  {
    listingTitile: "A Lovely 2 Bedroom Flat",
    price: "400000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Selewu Igbogbo",
    city: "Ikorodu",
    state: "Lagos",
    status: "old",
    agentContact: "07010568925",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-selewu-igbogbo-ikorodu-lagos-2GSKW",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Service 4 Bedroom Terrace Duplex",
    price: "3800000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08135540360",
    imagesProvided: "7",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-lagos-3GNHC",
    dateUpdated: "07 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-5GUCU",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "Luxury 3 Bedroom Flat",
    price: "700000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Oritamerin Elebu Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "07065057152",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oritamerin-elebu-akala-express-ibadan-oyo-3GUPG",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08063768619",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-parkview-estate-ikoyi-lagos-1GPWU",
    dateUpdated: "18 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex With Bq",
    price: "8000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Opp Lagos State Secretariat, Alausa",
    city: "Ikeja",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08133154602",
    imagesProvided: "30",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-opp-lagos-state-secretariat-alausa-ikeja-lagos-0GSYA",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08060283193",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-0GXCB",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Serviced 4bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Egerton Estate Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08060087745",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-egerton-estate-osapa-london-lekki-lagos-0GVQK",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1200000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "P And T Estate Ipaja Road Lagos Ipaja Road",
    city: "Ipaja",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07064937423",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-p-and-t-estate-ipaja-road-lagos-ipaja-road-ipaja-lagos-3GVKJ",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace / Massionette",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09064090448",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ologolo-lekki-lagos-8GNSH",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "4bedroom Terraced Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09064090448",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GMYQ",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08135540360",
    imagesProvided: "29",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GVUK",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Off Fila Osibo Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09064090448",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-off-fila-osibo-lekki-phase-1-lekki-lagos-5GVSG",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Nice 2 Bedroom Flat",
    price: "300000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Apata Brent More Apata",
    city: "Ibadan",
    state: "Oyo",
    status: "Furnished",
    agentContact: "09056267480",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-apata-brent-more-apata-ibadan-oyo-3GXGC",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Wuye District",
    city: "Wuye",
    state: "Abuja",
    status: "Furnished",
    agentContact: "08106600637",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuye-district-wuye-abuja-2GXGC",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Off Allen Avenue Estate Allen Avenue",
    city: "Ikeja",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07026933904",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-allen-avenue-estate-allen-avenue-ikeja-lagos-1GXGC",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Dideolu Court Estate Ogba Ikeja Lagos Nigeria Ajayi Road",
    city: "Ogba",
    state: "Lagos",
    status: "Furnished",
    agentContact: "09065161162",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-dideolu-court-estate-ogba-ikeja-lagos-nigeria-ajayi-road-ogba-lagos-5GXGA",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "4500000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Omole Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08165035582",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-omole-phase-1-ojodu-lagos-3GXFZ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "1500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Good Homes Estate",
    city: "Lokogoma",
    state: "Abuja",
    status: "Furnished",
    agentContact: "08180294600",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-good-homes-estate-lokogoma-abuja-5GXFX",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "2000000",
    bathrooms: "4",
    beds: "5",
    toilets: "4",
    street: "Oregun",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08033648310",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-oregun-ikeja-lagos-4GXEZ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Lovely 5 Bedroom Duplex",
    price: "3500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Peter Odili Extension, Woji Trans Amadi Port",
    city: "Harcourt",
    state: "Rivers",
    status: "old",
    agentContact: "08063105936",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-peter-odili-extension-woji-trans-amadi-port-harcourt-rivers-0GXEZ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Ambassadorial Duplex",
    price: "40000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "unstated",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "07035743511",
    imagesProvided: "20",
    listingURL: "https://www.propertypro.ng/property/house-for-rent-asokoro-abuja-1EYNF",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Terrace Duplex",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Maitama",
    state: "Abuja",
    status: "old",
    agentContact: "07035743511",
    imagesProvided: "20",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-maitama-abuja-3FCYU",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "Beautiful 5 Bedroom Detached Duplex With Bq",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-0GXEY",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Duplex",
    price: "2500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Orchid Road By Eleganza Bus Stop Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07016328119",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-orchid-road-by-eleganza-bus-stop-chevron-lekki-lagos-0GUKH",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Spacious 3 Bedroom Flat",
    price: "1800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08068361629",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-sangotedo-ajah-lagos-3GXEK",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Flat",
    price: "300000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Mogana Off Tipper Garage Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09056267480",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-mogana-off-tipper-garage-akala-express-ibadan-oyo-3GXDY",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ogudu Gra",
    city: "Ogudu",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09083016090",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ogudu-gra-ogudu-lagos-0GXBZ",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Well Maintained 4 Bedroom Terrace House",
    price: "2500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Golden Park Estate Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07064694261",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-golden-park-estate-sangotedo-ajah-lagos-5GSDE",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "1800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Peace Estate Ogidan",
    city: "Sangotedo",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07064694261",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-peace-estate-ogidan-sangotedo-lagos-0GSTC",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace House",
    price: "7000000",
    bathrooms: "4",
    beds: "3",
    toilets: "3",
    street: "Off Oba Akinjobi/oba Dosunmu Ikeja Gra",
    city: "Ikeja",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09134807405",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-oba-akinjobi-oba-dosunmu-ikeja-gra-ikeja-lagos-4GXBG",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "In Close Proximity To Estates Like Land Wey, Pennek, Revolution Plus Etc Ogombo",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09015885739",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-in-close-proximity-to-estates-like-land-wey-pennek-revolution-plus-etc-ogombo-ajah-lagos-9GVUQ",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "300000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Omolayo Estate Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "Serviced",
    agentContact: "08149249272",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-omolayo-estate-akobo-ibadan-oyo-5GVJY",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Berger",
    city: "Ojodu",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08165035582",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-berger-ojodu-lagos-2GXBF",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "11000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Banana Island Estate Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08063190555",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-estate-banana-island-ikoyi-lagos-6GXBC",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1800000",
    bathrooms: "1",
    beds: "2",
    toilets: "1",
    street: "Off Cole Street By Olufemi Ogunlana",
    city: "Surulere",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08034050731",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-cole-street-by-olufemi-ogunlana-surulere-lagos-2GWHM",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "4500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09034420031",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ologolo-lekki-lagos-6GWYH",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Spacious 2 Bedroom Flat",
    price: "1300000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Pedro By Charley Boy Bus Stop",
    city: "Gbagada",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08182343303",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-pedro-by-charley-boy-bus-stop-gbagada-lagos-6GWYG",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08067081484",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GWYF",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "5 Bedroom Terrace Duplex",
    price: "6500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "After Catholic Church Life",
    city: "Camp",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "07031587248",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-after-catholic-church-life-camp-abuja-3GWEX",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Bungalow",
    price: "1500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Arougba Gra Extension",
    city: "Oredo",
    state: "Edo",
    status: "old",
    agentContact: "08062881764",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-arougba-gra-extension-oredo-edo-3GWTD",
    dateUpdated: "02 Jul 2022",
  },
  {
    listingTitile: "Exquisitely Finished 4 Bedroom Duplex",
    price: "3500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08060255244",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-sangotedo-ajah-lagos-2GSAU",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-4GWRY",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Newly Built Of 3bedroom Flat",
    price: "700000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Wisdom Estate Akobo Ojurin Olorunda Road",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09050518082",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-wisdom-estate-akobo-ojurin-olorunda-road-ibadan-oyo-8GAXQ",
    dateUpdated: "10 Feb 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "10000000",
    bathrooms: "5",
    beds: "5",
    toilets: "7",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07012436130",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GWMQ",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile:
      "A Luxurious Finished, Furnished & Serviced 3 Bedroom Terrace Duplex With 1room Bq",
    price: "8500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Utako District",
    city: "Utako",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08106600637",
    imagesProvided: "23",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-utako-district-utako-abuja-6GVSC",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "A Brand New Spacious 4 Bedroom Terrace Duplex With 1room Bq",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Jahi",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08106600637",
    imagesProvided: "12",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jahi-abuja-0GVCR",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace House",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Lekk Scheme One Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07084372290",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekk-scheme-one-lekki-phase-1-lekki-lagos-7GVWE",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "Serviced New 4bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lifecamp District Life",
    city: "Camp",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08106600637",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lifecamp-district-life-camp-abuja-3GLZH",
    dateUpdated: "27 Apr 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "1",
    street: "unstated",
    city: "Jabi",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08053097777",
    imagesProvided: "8",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-jabi-abuja-9GWQM",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Brand New 2 Bedroom Terraced Duplex",
    price: "3500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Naf Valley Estate Asokoro",
    city: "Asokoro",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08056267437",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-naf-valley-estate-asokoro-asokoro-abuja-9GWMN",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-lekki-lagos-7GWRY",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "A Brand New 4 Bedroom Semi Detached Duplex With 1room Bq",
    price: "7500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Jahi District",
    city: "Jahi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "25",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jahi-district-jahi-abuja-9GVHU",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "250000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Behind Timber Shed ,oil Village ,mahuta",
    city: "Chikun",
    state: "Kaduna",
    status: "old",
    agentContact: "08067992859",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-behind-timber-shed-oil-village-mahuta-chikun-kaduna-7GWRU",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "6 Numbers 2 Bedroom Flats",
    price: "5500000",
    bathrooms: "3",
    beds: "2",
    toilets: "2",
    street: "Park View Estate Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "07084372290",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-park-view-estate-parkview-estate-ikoyi-lagos-9GTJL",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile:
      "A Tastefully Finished Spacious Brand New 4 Bedroom Terrace Duplex With 1room Bq",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Jahi District",
    city: "Jahi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jahi-district-jahi-abuja-2GMRN",
    dateUpdated: "03 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "New Road Before Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09029604948",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-new-road-before-chevron-lekki-lagos-9GTJY",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "Beautiful 3 Bedroom Semi Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Airport Road",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08067992859",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-airport-road-lugbe-abuja-0GWQL",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Serviced 4bedroom Semi Detached House",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "4",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08030619771",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-0GLRD",
    dateUpdated: "25 Apr 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08037836842",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-agungi-lekki-lagos-5GUDB",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "55000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08037836842",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-banana-island-ikoyi-lagos-6GPGS",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Fully Detached Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09029604948",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-0GVNL",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09080088779",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-1GPDX",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "Executive 3 Bedroom Flat",
    price: "1700000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Isheri North",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-isheri-north-ojodu-lagos-1GVMX",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Serviced 2 Bedroom Apartment",
    price: "16000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Eko Atlantic Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-eko-atlantic-victoria-island-lagos-3GUDH",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Serviced 2 Bedroom Flat",
    price: "3000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "By Pinnacle Filing Station Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08133194443",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-by-pinnacle-filing-station-lekki-phase-1-lekki-lagos-1GVHC",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "1200000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Awoyaya",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08137224561",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-awoyaya-ajah-lagos-7GUWJ",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09085096183",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-5GRTG",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "1600000",
    bathrooms: "2",
    beds: "3",
    toilets: "2",
    street: "Gbagada Phase2 Extension Phase 2",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "08148495671",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-gbagada-phase2-extension-phase-2-gbagada-lagos-5GVYE",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09014957322",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-0GQGX",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "Fantastic 3 Bedroom Flat",
    price: "1200000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Ayetooro Street Off Adebola Ojomo Aguda",
    city: "Surulere",
    state: "Lagos",
    status: "old",
    agentContact: "08034050731",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ayetooro-street-off-adebola-ojomo-aguda-surulere-lagos-7GRQE",
    dateUpdated: "29 May 2022",
  },
  {
    listingTitile: "5 Bedroom Terraced Duplex",
    price: "15000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "09080088779",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-victoria-island-lagos-4GPHJ",
    dateUpdated: "14 May 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Detached Duplex",
    price: "13000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-victoria-island-lagos-0GTPF",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Oniru Estate Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "09052778215",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-estate-oniru-victoria-island-lagos-9GRUX",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Semi Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08164687732",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-2GPUN",
    dateUpdated: "18 May 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Akala Estate Akobo Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09026318426",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-akala-estate-akobo-akobo-ibadan-oyo-8GVRV",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "Brand New Self Contain",
    price: "350000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "unstated",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "2",
    listingURL: "https://www.propertypro.ng/property/1-bedroom-house-for-rent-lugbe-abuja-4GUWV",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "2500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Transekulu",
    city: "Enugu",
    state: "Enugu",
    status: "old",
    agentContact: "08060036824",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-transekulu-enugu-enugu-1GPQH",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "A Tastefully Finished Spacious 4bedroom Bungalow",
    price: "2600000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Kado",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "14",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-kado-abuja-6GKKT",
    dateUpdated: "14 Apr 2022",
  },
  {
    listingTitile: "Fully Serviced 4 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-2nd-toll-gate-chevron-lekki-lagos-6GQWU",
    dateUpdated: "24 May 2022",
  },
  {
    listingTitile: "Descent 4 Bedroom Flat",
    price: "900000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Tipper Garage Area Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08163569554",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-tipper-garage-area-akala-express-ibadan-oyo-2GNHZ",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "Nicely Built 2 Bedroom Flat",
    price: "700000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "General Gas Estate Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09026318426",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-general-gas-estate-akobo-ibadan-oyo-1GRRD",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "Luxury 3 Bedroom Apartment",
    price: "15000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-island-lagos-3GSMY",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Semi Detached Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-2nd-toll-gate-chevron-lekki-lagos-4GQGP",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Idado",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09085096183",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-idado-lekki-lagos-5GUKM",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Units Of 3 Bedroom Flat",
    price: "6500000",
    bathrooms: "4",
    beds: "3",
    toilets: "3",
    street: "Parkview Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08077738880",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-parkview-estate-ikoyi-lagos-7GSKM",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Harmony Crescent Idado",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09096405498",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-harmony-crescent-idado-lekki-lagos-5GSHA",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Off Adetokunbo Ademola Ademola Adetokunbo Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08086267650",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-adetokunbo-ademola-ademola-adetokunbo-victoria-island-lagos-6GMZH",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Adesanya Street Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07016328119",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-adesanya-street-lekki-phase-1-lekki-lagos-7GPQD",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "3500000",
    bathrooms: "6",
    beds: "4",
    toilets: "6",
    street: "Orchid Hotel Road, Lekki Phase 2 Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08069604358",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-hotel-road-lekki-phase-2-ikota-lekki-lagos-8GVZK",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-8GQWP",
    dateUpdated: "24 May 2022",
  },
  {
    listingTitile: "4 Bedrooms Semi Detached Duplex",
    price: "3500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "River Park Estate, Airport Road",
    city: "Lugbe",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08067992859",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-river-park-estate-airport-road-lugbe-abuja-6GNGU",
    dateUpdated: "07 May 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Orchid Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "07016328119",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-orchid-road-chevron-lekki-lagos-2GUKS",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-2nd-toll-gate-chevron-lekki-lagos-1GQWR",
    dateUpdated: "24 May 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Terrace Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Wuye",
    city: "Wuye",
    state: "Abuja",
    status: "Furnished",
    agentContact: "08056267437",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuye-wuye-abuja-6GPNT",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "Executive 2 Bedroom Flat",
    price: "2000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Shangisha Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Furnished",
    agentContact: "09068622049",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-shangisha-kosofe-ikosi-lagos-0GVAU",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom House",
    price: "2800000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09085096183",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikate-lekki-lagos-0GTWZ",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09085096183",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ikate-lekki-lagos-4GUAF",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "Standard 3 Bedroom Bungalow",
    price: "1600000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Lugbe Axis Abuja",
    city: "Lugbe",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08061987440",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lugbe-axis-abuja-lugbe-abuja-0GUHH",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Nicely Built 2 Bedroom Apartment",
    price: "400000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Main Idi Ishin Idishin",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "07067980197",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-main-idi-ishin-idishin-ibadan-oyo-4GWEC",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "Serviced 3 Bedroom Apartment",
    price: "6000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GUDH",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GUPX",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace House",
    price: "3300000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09085096183",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-osapa-london-lekki-lagos-0GTYA",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: " ",
    beds: "4",
    toilets: " ",
    street: "34v Terraces, Orchid Hotel Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07049380760",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-34v-terraces-orchid-hotel-road-chevron-lekki-lagos-2GUVK",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Excellent Hotel Axis Ogba Bus Stop",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "08148495671",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-excellent-hotel-axis-ogba-bus-stop-ogba-lagos-5GUQT",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "900000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Adetola Street Off Aguda Aguda",
    city: "Surulere",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08034050731",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-adetola-street-off-aguda-aguda-surulere-lagos-6GSXE",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "Fantastic 2 Bedroom Flat",
    price: "1000000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Off Adeniran Ogunsanya Adeniran Ogunsanya",
    city: "Surulere",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08034050731",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-adeniran-ogunsanya-adeniran-ogunsanya-surulere-lagos-2GTKW",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached House",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "09085096183",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ologolo-lekki-lagos-3GSHW",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Well Maintained 3 Bedroom Terrace Duplex",
    price: "8500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Samuel Manuwa Victoria",
    city: "Island",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08181251091",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-samuel-manuwa-victoria-island-lagos-2GTUT",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "Self Contain",
    price: "500000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Ado",
    city: "Ajah",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "09085096183",
    imagesProvided: "7",
    listingURL: "https://www.propertypro.ng/property/1-bedroom-house-for-rent-ado-ajah-lagos-1GUCU",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "9 Bedroom Fully Detached Duplex",
    price: "70000000",
    bathrooms: "9",
    beds: "9",
    toilets: "1",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07049487086",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/9-bedroom-house-for-rent-banana-island-ikoyi-lagos-1GUQQ",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "10000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Maitama",
    state: "Abuja",
    status: "FurnishedServiced",
    agentContact: "08056267437",
    imagesProvided: "1",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-maitama-abuja-4GTCS",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "2 Bedeoom Flat",
    price: "800000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Newgarage Bariga New Garage",
    city: "Gbagada",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "09099980793",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-newgarage-bariga-new-garage-gbagada-lagos-8GVGL",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Spacious Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Abraham Estate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "07016328119",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-abraham-estate-chevron-lekki-lagos-3GSGZ",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Mini Flat",
    price: "800000",
    bathrooms: "2",
    beds: "1",
    toilets: "2",
    street: "New Garage",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "08148495671",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-new-garage-gbagada-lagos-6GUQZ",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Area 1 Garki",
    city: "1",
    state: "Abuja",
    status: "old",
    agentContact: "08147562407",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-area-1-garki-1-abuja-6GVRZ",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Brand New 2 Bedroom Flat",
    price: "500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Alakuko Area Alagbado Abule",
    city: "Egba",
    state: "Lagos",
    status: "old",
    agentContact: "08100078046",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-alakuko-area-alagbado-abule-egba-lagos-5GRXF",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "30000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Victoria Island Extension Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "09080088779",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-victoria-island-extension-victoria-island-lagos-3GNQC",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Victoria Island Extension Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "09080088779",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-victoria-island-extension-victoria-island-lagos-5GNPQ",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile:
      "A Super Luxurious Relatively Brand New Fully Detached 4 Bedroom Duplex Self Compound With All Rooms Ensuite, Pop Finishing, Ample Parking Space, At Alapere In A Gated Neighborhood",
    price: "2000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Off Oriola Street Alapere Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "08033657909",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-off-oriola-street-alapere-kosofe-ikosi-lagos-7FTYE",
    dateUpdated: "07 Dec 2021",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08164687732",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GNJQ",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Spring Garden, Opposite Orchid Hotel, By 2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08122986390",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-spring-garden-opposite-orchid-hotel-by-2nd-toll-gate-chevron-lekki-lagos-9GLHU",
    dateUpdated: "21 Apr 2022",
  },
  {
    listingTitile: "4bedroom Duplex",
    price: "6000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Orchid Road Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08094163102",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-orchid-road-ikota-lekki-lagos-9GMQW",
    dateUpdated: "02 May 2022",
  },
  {
    listingTitile: "Executive 3 Bedroom Flat",
    price: "1600000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Ogba Bus Stop",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ogba-bus-stop-ogba-lagos-8GWFJ",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "Executive 2 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Shangisha Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-shangisha-kosofe-ikosi-lagos-0GVGN",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom All Rooms En Suite Detached Duplex Plus A Room Bq",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08164687732",
    imagesProvided: "24",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GPUM",
    dateUpdated: "18 May 2022",
  },
  {
    listingTitile: "Executive 4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-9GUMD",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Beautiful 4 Bedroom Fully Detached Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "09087744002",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-victoria-island-lagos-2GNPV",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Apartment",
    price: "350000",
    bathrooms: "2",
    beds: "3",
    toilets: "2",
    street: "Agbofieti After Nihort School",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "07067980197",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agbofieti-after-nihort-school-ibadan-oyo-6GSNW",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "Modern 4 Bedroom Detached Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Hillcrest Estate",
    city: "Enugu",
    state: "Enugu",
    status: "old",
    agentContact: "08060036824",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-hillcrest-estate-enugu-enugu-3GVDL",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "6000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "07031650620",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-magodo-gra-phase-1-ojodu-lagos-6GTUU",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Wole Ariyo Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08181251091",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-wole-ariyo-lekki-phase-1-lekki-lagos-1GTVW",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Close To Blenco Shopping Mall Olokonla",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08062345097",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-close-to-blenco-shopping-mall-olokonla-ajah-lagos-7GSSY",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Off College Road Ifako Ogba",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "08148495671",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-college-road-ifako-ogba-ogba-lagos-1GVUC",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-2nd-toll-gate-chevron-lekki-lagos-5GSFU",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "Spacious 4 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "6",
    street: "Bode Thomas",
    city: "Surulere",
    state: "Lagos",
    status: "old",
    agentContact: "08093708615",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-bode-thomas-surulere-lagos-7GTEJ",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "Decent 4 Bedroom Terrace Duplex",
    price: "1600000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Atunrase Estate Atunrase Medina",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "09083016090",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-atunrase-estate-atunrase-medina-gbagada-lagos-5GSCX",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "Decent 4 Bedroom Flat",
    price: "900000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Tipper Garage Area Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08163569554",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-tipper-garage-area-akala-express-ibadan-oyo-3GNHZ",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "Standard 3 Bedroom Bungalow",
    price: "1500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "unstated",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "3",
    listingURL: "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lugbe-abuja-3GUXB",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Apartment",
    price: "500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Akinpade Iyana Olopa, Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09026318426",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-akinpade-iyana-olopa-akobo-ibadan-oyo-2GVCV",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Fully Furnished 3 Bedroom Flat",
    price: "9000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Admiralty Way Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08133194443",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-admiralty-way-lekki-phase-1-lekki-lagos-8GUHH",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached House",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Idado",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09098077985",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-idado-lekki-lagos-0GRSA",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "1200000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Okuyole Estate Gra Ibadan Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08104717713",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-okuyole-estate-gra-ibadan-oluyole-estate-ibadan-oyo-1GWJR",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "Brand New 4bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lifecamp District Life",
    city: "Camp",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: "27",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lifecamp-district-life-camp-abuja-8GJMP",
    dateUpdated: "07 Apr 2022",
  },
  {
    listingTitile: "Standard 1 Bedroom Apartment",
    price: "400000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "unstated",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "2",
    listingURL: "https://www.propertypro.ng/property/1-bedroom-house-for-rent-lugbe-abuja-1GUHJ",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Flat",
    price: "2500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Royal Court Off Mobil Road After Vgc Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08089633335",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-royal-court-off-mobil-road-after-vgc-ilaje-ajah-lagos-0GSFW",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Bungalow",
    price: "2500000",
    bathrooms: " ",
    beds: "3",
    toilets: " ",
    street: "Located Along Premiere Academy School",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08066627552",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-located-along-premiere-academy-school-lugbe-abuja-3GUHU",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Fully Detached 3 Bedroom Bungalow",
    price: "2500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Lugbe Airport Road",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lugbe-airport-road-lugbe-abuja-2GTPZ",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Millennium Estate Millenuim Ups",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "09050857650",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-millennium-estate-millenuim-ups-gbagada-lagos-3GUER",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Excellent Hotel Ogba Bus Stop",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "08148495671",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-excellent-hotel-ogba-bus-stop-ogba-lagos-2GUQT",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Bungalow",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "unstated",
    city: "Lokogoma",
    state: "Abuja",
    status: "old",
    agentContact: "08068329212",
    imagesProvided: "4",
    listingURL: "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lokogoma-abuja-7GWMA",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Cardogan Estate Jakande",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08077738880",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-cardogan-estate-jakande-lekki-lagos-1GRDP",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "2nd Toll Gate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-2nd-toll-gate-chevron-lekki-lagos-5GQGS",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Chevron Drive Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08133194443",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-drive-chevron-lekki-lagos-6GURL",
    dateUpdated: "18 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GRAB",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Detached Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-4GRAA",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "A Tastefully Finished Serviced Spacious 4bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Katampe Extension District (diplomatic Zone) Katampe",
    city: "Ext",
    state: "Abuja",
    status: "Furnished",
    agentContact: "08106600637",
    imagesProvided: "23",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-katampe-extension-district-diplomatic-zone-katampe-ext-abuja-0GPKH",
    dateUpdated: "15 May 2022",
  },
  {
    listingTitile: "2 Bedroom Bungalow",
    price: "750000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Novojo Estate By Sky Mall Opposite Blenco At Sangotedo Ajah Lekki, Lagos.",
    city: "Sangotedo",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09050857650",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-novojo-estate-by-sky-mall-opposite-blenco-at-sangotedo-ajah-lekki-lagos-sangotedo-lagos-9GTWV",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "Executive 3 And 2 Bedroom Flat",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Omole Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068622049",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-omole-phase-1-ojodu-lagos-8GVEG",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Tastefully Finished 5 Bedroom Terraced Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Jabi",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08033217920",
    imagesProvided: "24",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-jabi-abuja-9GMZN",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lifecamp District Life",
    city: "Camp",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08106600637",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lifecamp-district-life-camp-abuja-7GRHP",
    dateUpdated: "27 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "3500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Located Adjacent Citec Estate",
    city: "Dakibiyu",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08066627552",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-located-adjacent-citec-estate-dakibiyu-abuja-5GUPW",
    dateUpdated: "17 Jun 2022",
  },
  {
    listingTitile: "Executive 3 Bedroom Flat",
    price: "2000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068622049",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-magodo-gra-phase-1-ojodu-lagos-3GVUY",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Flat",
    price: "300000",
    bathrooms: "2",
    beds: "3",
    toilets: "2",
    street: "Gbongudu Akobo Ojurin Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "09026318426",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-gbongudu-akobo-ojurin-akobo-ibadan-oyo-0GVRW",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "Executive 2 Bedroom Flat",
    price: "2000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068622049",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-2GUME",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "7",
    street: "Marwa Traffic Light Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08133194443",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-marwa-traffic-light-lekki-phase-1-lekki-lagos-5GQDB",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Domino Axis Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07016328119",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-domino-axis-ologolo-lekki-lagos-0GTCA",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Abule Ijesha",
    city: "Yaba",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08106855223",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-abule-ijesha-yaba-lagos-8GSKV",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "4units Of 4 Bedroom Semi Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "08142223792",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-victoria-island-lagos-6GQCG",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikeja Gra Ikeja Gra",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08022569035",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikeja-gra-ikeja-gra-ikeja-lagos-3GUTZ",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07052101048",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-0GSQQ",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "Shared Apartment",
    price: "700000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Bera Estate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09013619321",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-bera-estate-chevron-lekki-lagos-0GVMP",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Apartment",
    price: "1200000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "After Blenco Supermarket Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08133194443",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-after-blenco-supermarket-sangotedo-ajah-lagos-2GTXK",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "Executive 3 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Adetola Street Aguda Aguda",
    city: "Surulere",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08034050731",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-adetola-street-aguda-aguda-surulere-lagos-1GSXF",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "10000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08101843892",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-oniru-victoria-island-lagos-4GQGN",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "Executive 4 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Alaka Estate",
    city: "Surulere",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08099275848",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-alaka-estate-surulere-lagos-8GNTH",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "Nicely Built 3 Bedroom Apartment",
    price: "500000",
    bathrooms: "2",
    beds: "3",
    toilets: "2",
    street: "Ashi Bodija",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "07067980197",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ashi-bodija-ibadan-oyo-2GWBR",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Lekki Gardens Estate",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09085096183",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lekki-gardens-estate-ajah-lagos-1GTRZ",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Fully Detached Duplex",
    price: "4000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Cooplag Estate Orchid Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08024025048",
    imagesProvided: "22",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-cooplag-estate-orchid-chevron-lekki-lagos-7GQGU",
    dateUpdated: "20 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Main Jericho Jericho",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "08076508977",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-main-jericho-jericho-ibadan-oyo-8GSPQ",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Close Landmark Coza Church Guzape",
    city: "Guzape",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "09069656035",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-close-landmark-coza-church-guzape-guzape-abuja-8GWKE",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "6 Bedroom Duplex For Rent At Victoria Island Lagos",
    price: "20000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Victoria Island Extension Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08136670481",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-victoria-island-extension-victoria-island-lagos-9GSJM",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Massive 6 Bedroom Detached Duplex",
    price: "25000000",
    bathrooms: "9",
    beds: "9",
    toilets: "9",
    street: "Off Fola Osibo Street Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08170355577",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/9-bedroom-house-for-rent-off-fola-osibo-street-lekki-phase-1-lekki-lagos-9GUYQ",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "5bedroom Semi Detached Duplex For Rent At Lekki Phase 1",
    price: "11000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Lekki Phase 1 Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08136670481",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-lekki-phase-1-lekki-phase-1-lekki-lagos-6GSVN",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "Studio Apartment",
    price: "1500000",
    bathrooms: "1",
    beds: "1",
    toilets: "1",
    street: "Chevy View Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08111888039",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-chevy-view-chevron-lekki-lagos-8GWAA",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Idado",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07047265825",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-idado-lekki-lagos-9GWDQ",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Terrace Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "1",
    street: "Guzape",
    city: "Guzape",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "09124604075",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-guzape-guzape-abuja-9GVMD",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "5",
    toilets: "5",
    street: "Magodo Phase1 1 Estate Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09041431420",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-magodo-phase1-1-estate-magodo-gra-phase-1-ojodu-lagos-6GTYA",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Duplex In A Serene Environment",
    price: "1200000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Woji Axis Port Harcourt Aba Expressway Port",
    city: "Harcourt",
    state: "Rivers",
    status: "ServicedNewly Built",
    agentContact: "09025433625",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-woji-axis-port-harcourt-aba-expressway-port-harcourt-rivers-2GEUR",
    dateUpdated: "11 Mar 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "5",
    toilets: "4",
    street: "Adeniyi Jones",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08064323103",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-adeniyi-jones-ikeja-lagos-5GNLT",
    dateUpdated: "09 May 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Apartment",
    price: "3000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Omole Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-omole-phase-1-ojodu-lagos-9GVCZ",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "New Built 3 Bedroom Maisonette",
    price: "5000000",
    bathrooms: "4",
    beds: "3",
    toilets: "5",
    street: "Abubakar Umar Street Katampe",
    city: "Ext",
    state: "Abuja",
    status: "old",
    agentContact: "08111100027",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-abubakar-umar-street-katampe-ext-abuja-8GVZQ",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Bungalow",
    price: "1000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Etate Eputu Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08111018414",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-etate-eputu-ibeju-lekki-lagos-2GWGT",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "13000000",
    bathrooms: "5",
    beds: "5",
    toilets: "1",
    street: "River Niger",
    city: "Maitama",
    state: "Abuja",
    status: "old",
    agentContact: "09124604075",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-river-niger-maitama-abuja-2GVHW",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Luxury Fully Detached 3 Bedroom Bungalow",
    price: "2700000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Thomas Estate Thomas Estate",
    city: "Ajah",
    state: "Lagos",
    status: "FurnishedServiced",
    agentContact: "08166666890",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-thomas-estate-thomas-estate-ajah-lagos-0GUUN",
    dateUpdated: "19 Jun 2022",
  },
  {
    listingTitile: "Beautiful 3bedroom Flat For Rent At Mobil Road Ajah Ilaje",
    price: "1400000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Moba Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "FurnishedNewly Built",
    agentContact: "08136670481",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-moba-ilaje-ajah-lagos-5GVFV",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Semi Detached House",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Inoyo Haven Estate Off Lekki Epe Expressway",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "07086062023",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-inoyo-haven-estate-off-lekki-epe-expressway-ajah-lagos-3GTLN",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1400000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Mobile Road Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-mobile-road-ilaje-ajah-lagos-4GRYW",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "Lovely 3 Bedroom Flat",
    price: "2800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08138800178",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ologolo-lekki-lagos-6GTVN",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "Renovated 4 Bedroom Duplex",
    price: "3000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Service, Serene And Gated Estate Abraham Adesanya Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08081676481",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-service-serene-and-gated-estate-abraham-adesanya-estate-ajah-lagos-8GVDJ",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "7000000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Kazeem Eletu Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08064303729",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-kazeem-eletu-osapa-london-lekki-lagos-9GRUE",
    dateUpdated: "30 May 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "5",
    toilets: "4",
    street: "Adeniyi Jones",
    city: "Ikeja",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08064323103",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-adeniyi-jones-ikeja-lagos-7GNLV",
    dateUpdated: "09 May 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Flat",
    price: "900000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ifako Ogba",
    city: "Ogba",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07033245877",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ifako-ogba-ogba-lagos-8GUGB",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Magodo Gra Phase 1 Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09041431420",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-magodo-gra-phase-1-magodo-gra-phase-1-ojodu-lagos-2GTYA",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Duplex",
    price: "20000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Banana Island Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08120765101",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-banana-island-banana-island-ikoyi-lagos-4GMCZ",
    dateUpdated: "28 Apr 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Detached Duplex",
    price: "1500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Jehovah Witness Road, Bogije, Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08165979633",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-jehovah-witness-road-bogije-ibeju-lekki-lagos-8GUXA",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "450000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Elemoro Close To Kajola Bus Stop Oribanwa Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09027953269",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-elemoro-close-to-kajola-bus-stop-oribanwa-ibeju-lekki-lagos-6GVRX",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "2000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Abijo",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08060255244",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-abijo-ajah-lagos-0GWRR",
    dateUpdated: "01 Jul 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Chevron Axis Lekki Phase 2",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08138433272",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-chevron-axis-lekki-phase-2-lekki-lagos-7GUFM",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Standard 3 Bedroom Flat",
    price: "700000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Idishin Extension, Alafara Idishin",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "08076508977",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-idishin-extension-alafara-idishin-ibadan-oyo-9GWFF",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09039556889",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-ikota-lekki-lagos-1GPQD",
    dateUpdated: "16 May 2022",
  },
  {
    listingTitile: "Standard 3 Bedroom Apartment",
    price: "600000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Oluseyi Eleyele",
    city: "Ibadan",
    state: "Oyo",
    status: "ServicedNewly Built",
    agentContact: "08076508977",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-oluseyi-eleyele-ibadan-oyo-8GRPR",
    dateUpdated: "29 May 2022",
  },
  {
    listingTitile: "Lovely 2 Bedroom Flat",
    price: "1200000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Adetola Aguda",
    city: "Surulere",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07012152081",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-adetola-aguda-surulere-lagos-2GTSA",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "Brand New 2 Bedroom Bungalow",
    price: "400000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Mowe Obafemi",
    city: "Owode",
    state: "Ogun",
    status: "ServicedNewly Built",
    agentContact: "08050383215",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-mowe-obafemi-owode-ogun-9GSQE",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "Exquisite 4 Bedroom Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Springville Estate, Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07062746651",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-springville-estate-ikate-lekki-lagos-5GWBD",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08103065653",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-road-chevron-lekki-lagos-3GWFW",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Abijo",
    city: "Ajah",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08060255244",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-abijo-ajah-lagos-0GQWV",
    dateUpdated: "24 May 2022",
  },
  {
    listingTitile: "2 Bedroom Bungalow",
    price: "750000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Kajola Phase 2 Close To Gbogije Near Lakowe Lakes Gulf Course Oribanwa Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09027953269",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-kajola-phase-2-close-to-gbogije-near-lakowe-lakes-gulf-course-oribanwa-ibeju-lekki-lagos-7GVZR",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "7 Bedroom Detached House",
    price: "18000000",
    bathrooms: "6",
    beds: "7",
    toilets: "6",
    street: "Alagomeji Alagomeji",
    city: "Yaba",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08050383215",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/7-bedroom-house-for-rent-alagomeji-alagomeji-yaba-lagos-6GRMD",
    dateUpdated: "27 May 2022",
  },
  {
    listingTitile: "Standard 4 Bedroom Duplex With Bq",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Just By Northwest Filling Station Vgc",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138800178",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-just-by-northwest-filling-station-vgc-lekki-lagos-2GPZE",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Terraced Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "1",
    street: "Garki",
    city: "1",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "07017940496",
    imagesProvided: "15",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-garki-1-abuja-6GTTM",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2300000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Omole Phase 2 Estate Omole Phase 2",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09041431420",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-omole-phase-2-estate-omole-phase-2-ojodu-lagos-3GWLK",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "1500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Off Jehovah Witness Road, Bogije, Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08165979633",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-jehovah-witness-road-bogije-ibeju-lekki-lagos-0GUXD",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Terrace Duplex",
    price: "2700000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Orchid Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08103065653",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-orchid-road-chevron-lekki-lagos-8GWFV",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "Luxurious 5 Bedroom Fully Detached Duplex",
    price: "7500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikate Axis Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138433272",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikate-axis-ikate-lekki-lagos-7GTRZ",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Fully Detached Duplex",
    price: "5500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota Villa Estate, Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09079005774",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-villa-estate-ikota-lekki-lagos-3GVDE",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Flat",
    price: "1000000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Estate Berger",
    city: "Ojodu",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08020701333",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-estate-berger-ojodu-lagos-6GVWA",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "700000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "10 Stait Close Off Eneka Road Rumunduru Port Harcourt Aba Expressway Port",
    city: "Harcourt",
    state: "Rivers",
    status: "Newly Built",
    agentContact: "08056023264",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-10-stait-close-off-eneka-road-rumunduru-port-harcourt-aba-expressway-port-harcourt-rivers-8GSLF",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Newly Built 1 Bedroom Flat",
    price: "700000",
    bathrooms: "2",
    beds: "1",
    toilets: "2",
    street: "Woji Port Harcourt Obia Akpor Port",
    city: "Harcourt",
    state: "Rivers",
    status: "Newly Built",
    agentContact: "08056023264",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/1-bedroom-house-for-rent-woji-port-harcourt-obia-akpor-port-harcourt-rivers-3GUFR",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Flat",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08038125965",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-7GMZW",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "Newly Built 4bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Omole Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08031132776",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-omole-phase-1-ojodu-lagos-6GPST",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Bakare Estate Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08068361629",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-bakare-estate-agungi-lekki-lagos-8GSGS",
    dateUpdated: "03 Jun 2022",
  },
  {
    listingTitile: "Serviced 3bedroom Flat",
    price: "13000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Lawrence Street, Off Alexander Gerard Road",
    city: "Ikoyi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07086661335",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-lawrence-street-off-alexander-gerard-road-ikoyi-lagos-7GNJW",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "A Tastefully Finished 5bedroom Fully Detached Duplex With 2room Bq",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-detached-duplex-house-for-rent-jabi-district-jabi-abuja-7EMYX",
    dateUpdated: "07 Apr 2021",
  },
  {
    listingTitile: "A Tastefully Finished 5bedroom Fully Detached Duplex With 2room Bq",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-detached-duplex-house-for-rent-jabi-district-jabi-abuja-6EMYX",
    dateUpdated: "07 Apr 2021",
  },
  {
    listingTitile: "A Tastefully Finished 5bedroom Fully Detached Duplex With 2room Bq",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-detached-duplex-house-for-rent-jabi-district-jabi-abuja-5EMYX",
    dateUpdated: "07 Apr 2021",
  },
  {
    listingTitile: "A Tastefully Finished 5bedroom Fully Detached Duplex With 2room Bq",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "old",
    agentContact: "08106600637",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-detached-duplex-house-for-rent-jabi-district-jabi-abuja-4EMYX",
    dateUpdated: "07 Apr 2021",
  },
  {
    listingTitile: "Brand New 4bedroom Terrace Duplex",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "2nd Toll Gate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08035881085",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-terraced-duplex-house-for-rent-2nd-toll-gate-lekki-lagos-4DSGL",
    dateUpdated: "10 Aug 2020",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "2500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07051883525",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ikate-lekki-lagos-4GXSU",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Detached House With 2 Separate One Bedroom Apartments",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Close To Total Filling Station Eden Garden Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "09027260414",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-close-to-total-filling-station-eden-garden-estate-ajah-lagos-4GMDX",
    dateUpdated: "28 Apr 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "450000000",
    bathrooms: "4",
    beds: "4",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09058645473",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-3GXSN",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Exquisite 4 Bedroom Terrace House",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ifako Gbagada Ifako Gbagada",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "09134807405",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ifako-gbagada-ifako-gbagada-gbagada-lagos-9GXSM",
    dateUpdated: "11 Jul 2022",
  },
  {
    listingTitile: "Serviced 2 Bedroom Apartment",
    price: "14000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-banana-island-ikoyi-lagos-3GXQX",
    dateUpdated: "10 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Townhouse",
    price: "8000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Central Ikoyi Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-central-ikoyi-old-ikoyi-ikoyi-lagos-2EUXF",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Unfurnished 3 Bedroom Maisonette",
    price: "16000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Banana Island",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-banana-island-ikoyi-lagos-3ECLF",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached House",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osborne 1 Osborne Foreshore Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08124269637",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osborne-1-osborne-foreshore-estate-ikoyi-lagos-9EKDD",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4bedroom Terrace Duplex Apartment",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Close To African Community School",
    city: "Asokoro",
    state: "Abuja",
    status: "ServicedNewly Built",
    agentContact: "08053979149",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-close-to-african-community-school-asokoro-abuja-5GJHG",
    dateUpdated: "05 Apr 2022",
  },
  {
    listingTitile: "Newly Built 5bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Close To Nnpc",
    city: "Guzape",
    state: "Abuja",
    status: "old",
    agentContact: "08053979149",
    imagesProvided: "20",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-close-to-nnpc-guzape-abuja-3GNPM",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Decent 2 Bedroom Flat",
    price: "1500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Wilmer Isheri Magodo Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-wilmer-isheri-magodo-kosofe-ikosi-lagos-4GXCU",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "700000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Solam Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09023730900",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-solam-oluyole-estate-ibadan-oyo-3GLXR",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Serviced 2 Bedroom Flat",
    price: "2800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08143129775",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GWSW",
    dateUpdated: "02 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Maisonette Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09074162101",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-lekki-lagos-3GVJJ",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Bankole Lukmon Street Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09068786533",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-bankole-lukmon-street-ologolo-lekki-lagos-0GVKU",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Semi Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Alagomeji",
    city: "Yaba",
    state: "Lagos",
    status: "old",
    agentContact: "09068786533",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-alagomeji-yaba-lagos-2GJPR",
    dateUpdated: "07 Apr 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Detached Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Orchid",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08107272392",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-orchid-lekki-lagos-9GTRU",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09074162101",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-5GVKH",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Terrace Duplex",
    price: "7500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09068786533",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ologolo-lekki-lagos-4GKMG",
    dateUpdated: "14 Apr 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Detached Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09068786533",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-8GTGM",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "3700000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08067329172",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-2GPXT",
    dateUpdated: "18 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached House",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08107272392",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-5GSTR",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "6 Bedroom Semi Detached Duplex",
    price: "25000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "unstated",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08139265236",
    imagesProvided: "24",
    listingURL: "https://www.propertypro.ng/property/6-bedroom-house-for-rent-ikoyi-lagos-9GUCK",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09121180993",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-9GVPH",
    dateUpdated: "23 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Serviced Apartment",
    price: "3500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07051883525",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-osapa-london-lekki-lagos-9GVAE",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Fully Detached 4 Bedroom Flat",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068786533",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-3GWYX",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Serviced 3 Bedroom Flat",
    price: "10000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09121180993",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-island-lagos-2GXJA",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07051883525",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-agungi-lekki-lagos-9GXJH",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "New Built 4 Bedroom Terrace Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Spring Garden Estate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068786533",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-spring-garden-estate-lekki-lagos-5GXFF",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Fully Serviced 4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "07051883525",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-3GXKG",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Nice 3 Bedroom Flat",
    price: "300000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Odeku Tipper Garage Area Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "09056267480",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-odeku-tipper-garage-area-akala-express-ibadan-oyo-5GXKR",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "4000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Palace Road, Oniru Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "08133194443",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-palace-road-oniru-oniru-victoria-island-lagos-2GXKN",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07047265825",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-osapa-london-lekki-lagos-4GXJQ",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "800000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Abule Egba Abule",
    city: "Egba",
    state: "Lagos",
    status: "old",
    agentContact: "08020701333",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-abule-egba-abule-egba-lagos-8GXJN",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Flat",
    price: "800000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Palm Crescent Badore",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08133194443",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-palm-crescent-badore-ajah-lagos-0GXHB",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Luxury 6 Bedroom Duplex With Bq, A/c And Generator To Let In Asokoro Main",
    price: "25000000",
    bathrooms: "1",
    beds: "6",
    toilets: "1",
    street: "unstated",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "08180294600",
    imagesProvided: "2",
    listingURL: "https://www.propertypro.ng/property/6-bedroom-house-for-rent-asokoro-abuja-3GVVF",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "Serviced 6 Bedroom Duplex With Generator And Bq To Let In Asokoro Main",
    price: "30000000",
    bathrooms: "1",
    beds: "6",
    toilets: "1",
    street: "unstated",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "08180294600",
    imagesProvided: "3",
    listingURL: "https://www.propertypro.ng/property/6-bedroom-house-for-rent-asokoro-abuja-8GVVF",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Apartment",
    price: "1000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "unstated",
    city: "Lugbe",
    state: "Abuja",
    status: "old",
    agentContact: "08061987440",
    imagesProvided: "1",
    listingURL: "https://www.propertypro.ng/property/2-bedroom-house-for-rent-lugbe-abuja-7GXGY",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08067491442",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GXGX",
    dateUpdated: "07 Jul 2022",
  },
  {
    listingTitile: "Well Finished 5 Bedrooms Fully Detached Duplex",
    price: "8000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08033076102",
    imagesProvided: "19",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-8GQKA",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Townhouse",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "3",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08112870896",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-4GNEC",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "4000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Millennium Estate, Gbagada, Lagos. Millenuim Ups",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "08038592381",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-millennium-estate-gbagada-lagos-millenuim-ups-gbagada-lagos-4GVFL",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Serviced 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-1GQBQ",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "Super Clean 4bedroom Semi Detached Duplex With Bq",
    price: "10000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GQBJ",
    dateUpdated: "19 May 2022",
  },
  {
    listingTitile: "Furnished 3 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Monastery Road Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-monastery-road-sangotedo-ajah-lagos-5GRQB",
    dateUpdated: "29 May 2022",
  },
  {
    listingTitile: "5bedroom Detached Duplex",
    price: "6500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Omole Phase1 Agidingbi",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08063768619",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-omole-phase1-agidingbi-ikeja-lagos-0GLKC",
    dateUpdated: "22 Apr 2022",
  },
  {
    listingTitile: "Newly Built 5bedroom Semi Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GRFQ",
    dateUpdated: "26 May 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Semi Detached Duplex",
    price: "12000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08105605371",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-osapa-london-lekki-lagos-5GQWL",
    dateUpdated: "24 May 2022",
  },
  {
    listingTitile: "3 Bedroom Duplex",
    price: "4100000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "B Estate Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08063768619",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-b-estate-agungi-lekki-lagos-0GSVF",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "6 Bedroom Fully Detached House",
    price: "18000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08182122039",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-7GXFJ",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07030444906",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GXDE",
    dateUpdated: "06 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "600000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Adetokun After Nihort School",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "07067980197",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-adetokun-after-nihort-school-ibadan-oyo-8GXCF",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Furnished 2 Bedroom Bungalow",
    price: "3500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "unstated",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "08037144195",
    imagesProvided: "5",
    listingURL: "https://www.propertypro.ng/property/2-bedroom-house-for-rent-asokoro-abuja-3GXCD",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Spacious And Clean Terrace Duplex Beside House On The Rock, Ikate, Lekki",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Around House On The Rock Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08138837188",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-around-house-on-the-rock-ikate-lekki-lagos-0GXCA",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ogudu Gra",
    city: "Ogudu",
    state: "Lagos",
    status: "old",
    agentContact: "07036613677",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ogudu-gra-ogudu-lagos-1GXBZ",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Well Built 4 Bedroom Semi Detached Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Wuye",
    state: "Abuja",
    status: "old",
    agentContact: "08147562407",
    imagesProvided: "1",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuye-abuja-0GXBY",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Nicely Built 2 Bedroom Apartment",
    price: "300000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Johnson Awe After Sharp Corner",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "07067980197",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-johnson-awe-after-sharp-corner-ibadan-oyo-7GXBX",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "07036613677",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-8GWZM",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Executive 3 Bedroom Flat",
    price: "1500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-magodo-gra-phase-1-ojodu-lagos-6GWZL",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-4GWZL",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Omole Phase 2",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-omole-phase-2-ojodu-lagos-0GWAM",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1700000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Cmd Road Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-cmd-road-kosofe-ikosi-lagos-2GWZL",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-0GWZL",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-9GWZK",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Standard 2 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Shangisha Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-shangisha-kosofe-ikosi-lagos-7GWZK",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-3GWZK",
    dateUpdated: "05 Jul 2022",
  },
  {
    listingTitile: "Luxury 5 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Gudu District,",
    city: "Apo",
    state: "Abuja",
    status: "old",
    agentContact: "08147562407",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-gudu-district-apo-abuja-2GHVT",
    dateUpdated: "02 Apr 2022",
  },
  {
    listingTitile: "Brand New 4 Bedroom Terraced Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Wuye",
    state: "Abuja",
    status: "old",
    agentContact: "08056267437",
    imagesProvided: "11",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuye-abuja-6GWZC",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Newly Built 5 Bedroom Duplex",
    price: "5500000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "unstated",
    city: "Gaduwa",
    state: "Abuja",
    status: "old",
    agentContact: "07062047199",
    imagesProvided: "6",
    listingURL: "https://www.propertypro.ng/property/5-bedroom-house-for-rent-gaduwa-abuja-2GWZB",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Bungalow",
    price: "1500000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Landmark Is Pengassin 1",
    city: "Lokogoma",
    state: "Abuja",
    status: "old",
    agentContact: "07062047199",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-landmark-is-pengassin-1-lokogoma-abuja-8GWNE",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "Spacious 3 Bedroom Flat",
    price: "5000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Omorinre Johnson",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08033842143",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-omorinre-johnson-lekki-lagos-9GWYZ",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached House",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "White Oak Estate Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07086062023",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-white-oak-estate-ologolo-lekki-lagos-5GWYX",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Well Maintained 2 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07086062023",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-osapa-london-lekki-lagos-2GWYX",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "3 Bedroom Luxury Apartment",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "Estate Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09158670560",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-estate-magodo-gra-phase-1-ojodu-lagos-9GPBH",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "Tastefully Built 2 Bedroom Flat",
    price: "1000000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Abiodun Berger",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09158670560",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-abiodun-berger-ojodu-lagos-2GNRA",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "Executive 2 Bedroom Flat",
    price: "800000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Olowora",
    city: "Ojodu",
    state: "Lagos",
    status: "Serviced",
    agentContact: "09068622049",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-olowora-ojodu-lagos-5GWYU",
    dateUpdated: "04 Jul 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Gardens Estate",
    city: "Ajah",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09058645473",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-gardens-estate-ajah-lagos-4GNVB",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08062345097",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-8FVAX",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached House",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "09087744002",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GSEW",
    dateUpdated: "02 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "6500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Off Palace Road Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "08133194443",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-palace-road-oniru-victoria-island-lagos-2GWEZ",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "4500000",
    bathrooms: "5",
    beds: "5",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08062345097",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ikota-lekki-lagos-3GPBZ",
    dateUpdated: "13 May 2022",
  },
  {
    listingTitile: "Spacious 3 Bedroom Flat",
    price: "3000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Furnished",
    agentContact: "09058645473",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikate-lekki-lagos-2GWFX",
    dateUpdated: "29 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Detached Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08164687732",
    imagesProvided: "26",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-9GNJQ",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "Luxury 6 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "6",
    beds: "6",
    toilets: "7",
    street: "Wuye",
    city: "Wuye",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08147562407",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-wuye-wuye-abuja-3GQXQ",
    dateUpdated: "25 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "1800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Isheri North",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09068622049",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-isheri-north-ojodu-lagos-7GNCF",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "By Setraco,",
    city: "Gwarinpa",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "09050857650",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-by-setraco-gwarinpa-abuja-8GSNC",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Lovely 4 Bedroom Terrace Duplex",
    price: "2000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Abraham Adesanya Estate",
    city: "Ajah",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "09050857650",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-abraham-adesanya-estate-ajah-lagos-6GSNG",
    dateUpdated: "04 Jun 2022",
  },
  {
    listingTitile: "Brand New 3 Bedroom Bungalow",
    price: "5000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Suncity",
    city: "Galadinmawa",
    state: "Abuja",
    status: "old",
    agentContact: "08056267437",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-suncity-galadinmawa-abuja-2GVVF",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Apartment",
    price: "500000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Sharp Corner Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "07067980197",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-sharp-corner-oluyole-estate-ibadan-oyo-4GULQ",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Well Maintained 2 Bedroom Flat",
    price: "9000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Oniru Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "07030444906",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-oniru-victoria-island-lagos-6GUWP",
    dateUpdated: "20 Jun 2022",
  },
  {
    listingTitile: "Fully Serviced 4 Bedroom Semi Detached Duplex",
    price: "15000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Old Ikoyi",
    city: "Ikoyi",
    state: "Lagos",
    status: "ServicedNewly Built",
    agentContact: "07080033884",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-old-ikoyi-ikoyi-lagos-4GSPR",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "Twin 5 Bedroom Semi Detached Duplex With Bq To Let In Asokoro Main",
    price: "60000000",
    bathrooms: "7",
    beds: "5",
    toilets: "7",
    street: "Asokoro Main",
    city: "Asokoro",
    state: "Abuja",
    status: "old",
    agentContact: "08180294600",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-asokoro-main-asokoro-abuja-5GVVG",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "Four Bedroom Semi Detached Duplex",
    price: "6500000",
    bathrooms: "4",
    beds: "4",
    toilets: "6",
    street: "Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09058645473",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chevron-lekki-lagos-9GNAF",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "3 Bedroom Massionette",
    price: "8000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Victoria",
    city: "Island",
    state: "Lagos",
    status: "old",
    agentContact: "07080033884",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-victoria-island-lagos-0GURD",
    dateUpdated: "18 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "80000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Adeniyi Jones",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "07036613677",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-adeniyi-jones-ikeja-lagos-7GUGF",
    dateUpdated: "15 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Apartment",
    price: "500000",
    bathrooms: "2",
    beds: "3",
    toilets: "2",
    street: "Orange Gate Estate Oluyole Estate",
    city: "Ibadan",
    state: "Oyo",
    status: "Furnished",
    agentContact: "07067980197",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-orange-gate-estate-oluyole-estate-ibadan-oyo-7GVKX",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Buena Vista Estate Off Orchid Hotel Road Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09050857650",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-buena-vista-estate-off-orchid-hotel-road-chevron-lekki-lagos-6GQRZ",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "5 Bedroom Duplex",
    price: "2500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Thomas Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "09058645473",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-thomas-estate-ajah-lagos-5GWLN",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Semi Detached Duplex",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Sangotedo",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "09058645473",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-sangotedo-ajah-lagos-4GVVB",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Terrace Duplex Plus A Room Bq",
    price: "5250000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08164687732",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-2GHVQ",
    dateUpdated: "02 Apr 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Detached Duplex",
    price: "2500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Olokonla",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08062345097",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-olokonla-ajah-lagos-0GNJF",
    dateUpdated: "08 May 2022",
  },
  {
    listingTitile: "6 Bedroom Duplex",
    price: "1500000",
    bathrooms: "5",
    beds: "6",
    toilets: "6",
    street: "Royal Quarters Akala Express",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08163569554",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-royal-quarters-akala-express-ibadan-oyo-8GTWG",
    dateUpdated: "13 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "2000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Isheri North",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "16",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-isheri-north-ojodu-lagos-3GNCG",
    dateUpdated: "06 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Datched Duplex",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Off Alhaji Tokan Alaka Estate",
    city: "Surulere",
    state: "Lagos",
    status: "old",
    agentContact: "08034050731",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-alhaji-tokan-alaka-estate-surulere-lagos-5GNXM",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "4 Bedroom Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "6",
    street: "Idado",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09098077985",
    imagesProvided: "33",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-idado-lekki-lagos-5GUKL",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Executive 2 Bedroom Flat",
    price: "1200000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Isheri North",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09068622049",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-isheri-north-ojodu-lagos-7GRNW",
    dateUpdated: "28 May 2022",
  },
  {
    listingTitile: "4bedroom Semi Detached Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Southern View Estate Chevron",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08089633335",
    imagesProvided: "23",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-southern-view-estate-chevron-lekki-lagos-8GNVL",
    dateUpdated: "11 May 2022",
  },
  {
    listingTitile: "Luxury 4 Bedroom Fully Detached Duplex",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikeja Gra",
    city: "Ikeja",
    state: "Lagos",
    status: "Furnished",
    agentContact: "08033840643",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikeja-gra-ikeja-lagos-7GQJT",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08072800567",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-9GNRZ",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex Syl",
    price: "6500000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07069265294",
    imagesProvided: "1",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-lekki-lagos-8GQKB",
    dateUpdated: "21 May 2022",
  },
  {
    listingTitile: "6 Bedroom Duplex",
    price: "2000000",
    bathrooms: "6",
    beds: "6",
    toilets: "6",
    street: "Zone 4, Gate 2, Bashorun Housing Estate Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "FurnishedNewly Built",
    agentContact: "08167819140",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/6-bedroom-house-for-rent-zone-4-gate-2-bashorun-housing-estate-akobo-ibadan-oyo-7GTDN",
    dateUpdated: "08 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Urban Prime 2 Abraham Adesanya Estate",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "09027953269",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-urban-prime-2-abraham-adesanya-estate-ajah-lagos-3GRUL",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "College Road Ifako Ogba",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "07033245877",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-college-road-ifako-ogba-ogba-lagos-1GTQA",
    dateUpdated: "11 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Semi Detached Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Off Adeniyi Jones Estate",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "07026933904",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-off-adeniyi-jones-estate-ikeja-lagos-2GUJN",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "4000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Behind World Oil Ilasan",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-behind-world-oil-ilasan-lekki-lagos-7GMWA",
    dateUpdated: "04 May 2022",
  },
  {
    listingTitile: "Serviced 4bedroom Duplex For Rent At Lekki Phase 1",
    price: "9000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Lekki Phase 1 Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08136670481",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lekki-phase-1-lekki-phase-1-lekki-lagos-3GRVG",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Apartment",
    price: "1500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "New Bodija",
    city: "Ibadan",
    state: "Oyo",
    status: "Serviced",
    agentContact: "08076508977",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-new-bodija-ibadan-oyo-3GVWH",
    dateUpdated: "25 Jun 2022",
  },
  {
    listingTitile: "Well Maintained 3 Bedroom Flat",
    price: "1100000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Idi Agbon Town, Majek",
    city: "Ajah",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08165979633",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-idi-agbon-town-majek-ajah-lagos-1GTUX",
    dateUpdated: "12 Jun 2022",
  },
  {
    listingTitile: "Furnished 2 Bedroom Flat For Rent In Jabi",
    price: "7500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08037144195",
    imagesProvided: 3,
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-jabi-district-jabi-abuja-6GTJL",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "4000000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Jabi District",
    city: "Jabi",
    state: "Abuja",
    status: "Serviced",
    agentContact: "08037144195",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-jabi-district-jabi-abuja-4GSRZ",
    dateUpdated: "06 Jun 2022",
  },
  {
    listingTitile: "Brand New 3 Bedroom Flat",
    price: "4000000",
    bathrooms: "4",
    beds: "3",
    toilets: "4",
    street: "Off Adeniyi Jones Estate",
    city: "Ikeja",
    state: "Lagos",
    status: "Serviced",
    agentContact: "07026933904",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-off-adeniyi-jones-estate-ikeja-lagos-8GUJK",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Flat",
    price: "350000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Olohunda Akobo",
    city: "Ibadan",
    state: "Oyo",
    status: "Serviced",
    agentContact: "09056267480",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-olohunda-akobo-ibadan-oyo-1GVXM",
    dateUpdated: "26 Jun 2022",
  },
  {
    listingTitile: "Studio Apartment ( Self Contained )",
    price: "1200000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Ikate Elegushi Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Serviced",
    agentContact: "08111888039",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-ikate-elegushi-ikate-lekki-lagos-7GEHV",
    dateUpdated: "08 Mar 2022",
  },
  {
    listingTitile: "Masters Bedroom Shared Apartment",
    price: "1500000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Osapa London Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08111888039",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-osapa-london-osapa-london-lekki-lagos-2FVZK",
    dateUpdated: "01 Jan 2022",
  },
  {
    listingTitile: "Detached 3 Bedroom Duplex",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ikolaba Estate/new Bodija Bodija",
    city: "Ibadan",
    state: "Oyo",
    status: "Newly Built",
    agentContact: "08076508977",
    imagesProvided: "6",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ikolaba-estate-new-bodija-bodija-ibadan-oyo-6GSPQ",
    dateUpdated: "05 Jun 2022",
  },
  {
    listingTitile: "Beautiful 4 Bedroom Semi Detached Duplex For Rent At Mobil Road Ajah Ilaje",
    price: "3000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Alaguntan Mobil Road Ajah Ilaje Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08136670481",
    imagesProvided: "11",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-alaguntan-mobil-road-ajah-ilaje-ilaje-ajah-lagos-7GUCD",
    dateUpdated: "14 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Apartment",
    price: "1400000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Iwaya",
    city: "Yaba",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08182343303",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-iwaya-yaba-lagos-0GRMQ",
    dateUpdated: "28 May 2022",
  },
  {
    listingTitile: "3 Bedroom Bungalow",
    price: "1100000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Peak Park Estate Oribanwa Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08024312255",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-peak-park-estate-oribanwa-ibeju-lekki-lagos-6GVFN",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "3500000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "River Valley Estate Ojodu Berger River Valley Estate",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08022292982",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-river-valley-estate-ojodu-berger-river-valley-estate-ojodu-lagos-0GPQY",
    dateUpdated: "17 May 2022",
  },
  {
    listingTitile: "4 Bedrooms Semi Detached Duplex",
    price: "6000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Chisco Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08124031574",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-chisco-ikate-lekki-lagos-3GRND",
    dateUpdated: "28 May 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "3000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Onike",
    city: "Yaba",
    state: "Lagos",
    status: "old",
    agentContact: "08182343303",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-onike-yaba-lagos-0GVMR",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terraced Duplex",
    price: "12000000",
    bathrooms: "4",
    beds: "4",
    toilets: "4",
    street: "Mojisola Onikoyi Estate",
    city: "Ikoyi",
    state: "Lagos",
    status: "old",
    agentContact: "08024950713",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-mojisola-onikoyi-estate-ikoyi-lagos-8GVHH",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "4500000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikota",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08139635919",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikota-lekki-lagos-9GQSG",
    dateUpdated: "23 May 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Lifecamp District Life",
    city: "Camp",
    state: "Abuja",
    status: "old",
    agentContact: "08037144195",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-lifecamp-district-life-camp-abuja-0GWBH",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "7000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "unstated",
    city: "Wuye",
    state: "Abuja",
    status: "old",
    agentContact: "08167819140",
    imagesProvided: "6",
    listingURL: "https://www.propertypro.ng/property/4-bedroom-house-for-rent-wuye-abuja-9GWLJ",
    dateUpdated: "30 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Ikate",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07069265294",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikate-lekki-lagos-1GUHS",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "Newly Built 4 Bedroom Terrace Duplex",
    price: "2200000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Jericho Main",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08076508977",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-jericho-main-ibadan-oyo-7GWCF",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1400000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Mobile Road Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-mobile-road-ilaje-ajah-lagos-9GWBR",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Brand New 3 Bedroom Flat",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Adekoya Estate Off College Road Ifako Ogba",
    city: "Ogba",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-adekoya-estate-off-college-road-ifako-ogba-ogba-lagos-4GVGU",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Decent 2 Bedroom Flat",
    price: "2200000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Millenuim Ups",
    city: "Gbagada",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-millenuim-ups-gbagada-lagos-6GVKM",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Detached Duplex",
    price: "2800000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Mobile Road Ilaje",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-mobile-road-ilaje-ajah-lagos-5GVKV",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "Decent 3 Bedroom Flat",
    price: "2000000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Ayodele Fanoiki Street Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "14",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-ayodele-fanoiki-street-magodo-gra-phase-1-ojodu-lagos-5GVSW",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "A Well Maintained 2 Bedroom Flat",
    price: "1100000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Sliverpoint Estate Badore",
    city: "Ajah",
    state: "Lagos",
    status: "old",
    agentContact: "08165979633",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-sliverpoint-estate-badore-ajah-lagos-7GNBA",
    dateUpdated: "05 May 2022",
  },
  {
    listingTitile: "4 Bedroom Fully Detached House",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Ikolaba Gra Bodija",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08022292982",
    imagesProvided: "3",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-ikolaba-gra-bodija-ibadan-oyo-3GVUH",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Detached Duplex",
    price: "5000000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "08138805351",
    imagesProvided: "10",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-magodo-gra-phase-1-ojodu-lagos-3GVTM",
    dateUpdated: "24 Jun 2022",
  },
  {
    listingTitile: "Furnished 4 Bedroom Duplex",
    price: "8000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Awuse Estate Opebi",
    city: "Ikeja",
    state: "Lagos",
    status: "old",
    agentContact: "08124031574",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-awuse-estate-opebi-ikeja-lagos-7GUJA",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "5 Bedroom Semi Detached Duplex",
    price: "8000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07069265294",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-6GUHS",
    dateUpdated: "16 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex With Bq",
    price: "4000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Osapa London Estate Osapa London",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08067081484",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-osapa-london-estate-osapa-london-lekki-lagos-2GKUC",
    dateUpdated: "17 Apr 2022",
  },
  {
    listingTitile: "Newly Built 3 Bedroom Terrace Duplex",
    price: "1500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Kajola Phase 2 Near Lakowe Lakes Gulf Course And Bgogije Oribanwa Ibeju",
    city: "Ibeju-Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09027953269",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-kajola-phase-2-near-lakowe-lakes-gulf-course-and-bgogije-oribanwa-ibeju-lekki-lagos-0GVZT",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Finished 5 Bedroom Detached Duplex",
    price: "5500000",
    bathrooms: "5",
    beds: "5",
    toilets: "6",
    street: "Ayoola Drive Bodija",
    city: "Ibadan",
    state: "Oyo",
    status: "old",
    agentContact: "08167819140",
    imagesProvided: "13",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-ayoola-drive-bodija-ibadan-oyo-5GNMD",
    dateUpdated: "09 May 2022",
  },
  {
    listingTitile: "Brand New 3 Bedroom Terrace Duplex",
    price: "3000000",
    bathrooms: "3",
    beds: "3",
    toilets: "1",
    street: "Kabusa Gardens",
    city: "Lokogoma",
    state: "Abuja",
    status: "old",
    agentContact: "09124604075",
    imagesProvided: "12",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-kabusa-gardens-lokogoma-abuja-9GWCM",
    dateUpdated: "28 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "3500000",
    bathrooms: "2",
    beds: "2",
    toilets: "2",
    street: "Off Admiralty Road Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08024950713",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-admiralty-road-lekki-phase-1-lekki-lagos-3GURQ",
    dateUpdated: "18 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Bungalow",
    price: "2200000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Ologolo",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "09069656035",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-ologolo-lekki-lagos-1GVEB",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Brand New 5 Bedrooms Fully Detached Duplex",
    price: "8000000",
    bathrooms: "6",
    beds: "5",
    toilets: "6",
    street: "Jabi Axis",
    city: "Jabi",
    state: "Abuja",
    status: "old",
    agentContact: "08097100871",
    imagesProvided: "18",
    listingURL:
      "https://www.propertypro.ng/property/5-bedroom-house-for-rent-jabi-axis-jabi-abuja-1GMUU",
    dateUpdated: "04 May 2022",
  },
  {
    listingTitile: "3 Bedroom Flat",
    price: "2800000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138805351",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-3GVGP",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Newly Built 2 Bedroom Duplex",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Olowora",
    city: "Ojodu",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138805351",
    imagesProvided: "4",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-olowora-ojodu-lagos-1GVZG",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Executive 4 Bedroom Terrace Duplex",
    price: "6000000",
    bathrooms: "5",
    beds: "4",
    toilets: "4",
    street: "Allen Ikeja Allen Avenue",
    city: "Ikeja",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08124586624",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-allen-ikeja-allen-avenue-ikeja-lagos-5GNXC",
    dateUpdated: "12 May 2022",
  },
  {
    listingTitile: "2 Bedroom Semi Detached Duplex",
    price: "2500000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Olokonla",
    city: "Ajah",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08139635919",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-olokonla-ajah-lagos-8GTHY",
    dateUpdated: "09 Jun 2022",
  },
  {
    listingTitile: "8 Bedroom Semi Detached Duplex",
    price: "10000000",
    bathrooms: "8",
    beds: "8",
    toilets: "8",
    street: "Lekki Phase 1",
    city: "Lekki",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08120092644",
    imagesProvided: "8",
    listingURL:
      "https://www.propertypro.ng/property/8-bedroom-house-for-rent-lekki-phase-1-lekki-lagos-3GWAW",
    dateUpdated: "27 Jun 2022",
  },
  {
    listingTitile: "Brand New 2 Bedroom Flat",
    price: "2000000",
    bathrooms: "2",
    beds: "2",
    toilets: "3",
    street: "Adekoya Estate Off College Road Ifako Ogba",
    city: "Ogba",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138805351",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-adekoya-estate-off-college-road-ifako-ogba-ogba-lagos-9GVGU",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "4 Bedroom Terrace Duplex",
    price: "10000000",
    bathrooms: "5",
    beds: "4",
    toilets: "5",
    street: "Maitama District",
    city: "Maitama",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08037144195",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-maitama-district-maitama-abuja-2GRZR",
    dateUpdated: "01 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Off Cmd Rd Cmd Road Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08138805351",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-off-cmd-rd-cmd-road-kosofe-ikosi-lagos-8GVGN",
    dateUpdated: "21 Jun 2022",
  },
  {
    listingTitile: "Spacious 3 Bedroom Flat",
    price: "700000",
    bathrooms: "3",
    beds: "3",
    toilets: "3",
    street: "United Estate Alagbole By The Bridge Yakoyo Alagbole",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "08022292982",
    imagesProvided: "7",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-united-estate-alagbole-by-the-bridge-yakoyo-alagbole-ojodu-lagos-8GVJF",
    dateUpdated: "22 Jun 2022",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "2500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "First Gate Jakande",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "07047265825",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-first-gate-jakande-lekki-lagos-5GTMP",
    dateUpdated: "10 Jun 2022",
  },
  {
    listingTitile: "Ready To Go: Newly Built 4 Numbers Of 5 Bedroom Fully Detached Duplex,",
    price: "190000000",
    bathrooms: " ",
    beds: " ",
    toilets: " ",
    street: "Magodo Gra Phase 2 Kosofe",
    city: "Kosofe/Ikosi",
    state: "Lagos",
    status: "old",
    agentContact: "08113881428",
    imagesProvided: "15",
    listingURL:
      "https://www.propertypro.ng/property/house-for-rent-magodo-gra-phase-2-kosofe-ikosi-lagos-1FBSX",
    dateUpdated: "26 Jul 2021",
  },
  {
    listingTitile: "2 Bedroom Flat",
    price: "1500000",
    bathrooms: "3",
    beds: "2",
    toilets: "3",
    street: "Magodo Gra Phase 1 Magodo Gra Phase 1",
    city: "Ojodu",
    state: "Lagos",
    status: "old",
    agentContact: "09041431420",
    imagesProvided: "2",
    listingURL:
      "https://www.propertypro.ng/property/2-bedroom-house-for-rent-magodo-gra-phase-1-magodo-gra-phase-1-ojodu-lagos-3GSUR",
    dateUpdated: "07 Jun 2022",
  },
  {
    listingTitile: "3 Bedroom Terrace Duplex",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Phase 1 Lekki Gardens Estate",
    city: "Ajah",
    state: "Lagos",
    status: "Newly Built",
    agentContact: "08067081484",
    imagesProvided: "17",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-phase-1-lekki-gardens-estate-ajah-lagos-4GNRS",
    dateUpdated: "10 May 2022",
  },
  {
    listingTitile: "A Fully Detached 3 Bedroom Bungalow",
    price: "2500000",
    bathrooms: "3",
    beds: "3",
    toilets: "4",
    street: "Von Garden Estate",
    city: "Lugbe",
    state: "Abuja",
    status: "Newly Built",
    agentContact: "08167819140",
    imagesProvided: "9",
    listingURL:
      "https://www.propertypro.ng/property/3-bedroom-house-for-rent-von-garden-estate-lugbe-abuja-4GRXZ",
    dateUpdated: "31 May 2022",
  },
  {
    listingTitile: "4 Bedroom Semi Detached Duplex",
    price: "5000000",
    bathrooms: "4",
    beds: "4",
    toilets: "5",
    street: "Agungi",
    city: "Lekki",
    state: "Lagos",
    status: "old",
    agentContact: "08100073388",
    imagesProvided: "5",
    listingURL:
      "https://www.propertypro.ng/property/4-bedroom-house-for-rent-agungi-lekki-lagos-0GTKM",
    dateUpdated: "10 Jun 2022",
  },
];

export default propertyProData;
